'use strict';
import angular from 'angular';
angular.module('modals.directives', [])
.directive('modalGen', modalGen);

//
// ModalGen Directive used to inject a non isolate scoped form into the modal template
// this uses the element attribute modal-type to determine what modal to compile without isolating the scope
//
modalGen.$inject = ['$compile'];

function modalGen($compile) {
    return {
        restrict: 'A',
        link: function(scope, elem, attrs) {

            function assignCampaignManager() {
                var modal = angular.element(
                    '<div class="modal-header">' +
                    '<h3 class="modal-title">{{title}}</h3>' +
                    '</div>' +
                    '<div class="modal-body">' +
                    '<div class="input-group col-sm-10">' +
                    '<select class="form-control" ng-model="selectedItem" ng-options="user as user.first_name + \' \' + user.last_name for user in users">' +
                    '</select>' +
                    ' <span ng-if="selectedItem && lineItem!==null" class="input-group-btn">' +
                    '<button ng-click="unAssign(lineItem)" class="btn btn-warning btn-sm">' +
                    '<b>X</b>' +
                    '</button>' +
                    '</span>' +
                    '</div>' +
                    '<br/><br/>' +
                    '<div class="form-group" ng-if="selectedItem">' +
                    '<div class="col-sm-10">' +
                    'Assign {{selectedItem.first_name}} {{selectedItem.last_name}} ({{selectedItem.email}}) as campaign manager?' +
                    '</div>' +
                    '</div>' +
                    '</div>' +
                    '<div class="modal-footer">' +
                    '<button class="btn btn-primary" ng-click="bulkUnassign()" ng-if="lineItem===null">Unassign All</button>' +
                    '<button class="btn btn-primary" ng-click="ok()">OK</button>' +
                    '<button class="btn btn-warning" ng-click="cancel()">Cancel</button>' +
                    '</div>');
                elem.append(modal);
                return modal;
            }

            function assignQueue() {
                var modal = angular.element(
                    '<div class="modal-header">' +
                    '<h3 class="modal-title">Assign Task To Queue</h3>' +
                    '</div>' +
                    '<div class="modal-body">' +
                    '<div class="form-group">' +
                    '<div class="col-sm-10">' +
                    '<select class="form-control" ng-model="selectedItem" ng-options="queue as queue.name for queue in queues">' +
                    '</select>' +
                    '</div>' +
                    '</div>' +
                    '<br/><br/>' +
                    '<div class="form-group" ng-if="selectedItem">' +
                    '<div class="col-sm-10">' +
                    'Assign task to Queue?' +
                    '</div>' +
                    '</div>' +
                    '</div>' +
                    '<div class="modal-footer">' +
                    '<button class="btn btn-primary" ng-click="ok()">OK</button>' +
                    '<button class="btn btn-warning" ng-click="cancel()">Cancel</button>' +
                    '</div>');
                elem.append(modal);
                return modal;
            }

            function reassign() {
                var modal = angular.element(
                    '<div class="modal-header reassign-modal">' +
                    '<h3 class="modal-title">{{title}}</h3>' +
                    '</div>' +
                    '<div class="modal-body users-list">' +
                    '<div class="form-inline form-group reassign-search">' +
                    '<label>Search Users: </label> <input type="text" class="form-control" ng-model="searchUsers" placeholder="Search Users" />' +
                    '</div>' +
                    '<table class="table reassign-table">' +
                    '<thead>' +
                    '<tr>' +
                    '<th>' +
                    '<a ng-click="sortType = \'in_out_status_id\'; sortReverse = !sortReverse;"> Availability <span ng-show="sortType == \'in_out_status_id\'" ng-class="sortReverse ? \'fa fa-caret-up\' : \'fa fa-caret-down\'"></span> </a>' +
                    '</th>' +
                    '<th>' +
                    '<a ng-click="sortType = \'first_name\'; sortReverse = !sortReverse;"> User Name <span ng-show="sortType == \'first_name\'" ng-class="sortReverse ? \'fa fa-caret-up\' : \'fa fa-caret-down\'"></span></a>' +
                    '</th>' +
                    '</tr>' +
                    '</thead>' +
                    '<tbody>' +
                    '<tr ng-repeat="user in users | filter:searchUsers | orderBy:sortType:sortReverse" class="users-list-items" ng-click="selectUser(user)" ng-class="{selected: selectedItem === user}">' +
                    '<td><i class="fa user-icon" ng-class="{\'fa\-check\-circle\-o\': user.in_out_status_id==36, \'fa\-history\': user.in_out_status_id==37, \'fa\-times\-circle\-o\': user.in_out_status_id==38 || user.in_out_status_id==39 || user.in_out_status_id==null, absence: user.in_out_status_id==39}"></i></td>' +
                    '<td>{{user.first_name}} {{user.last_name}}</td>' +
                    '</tr>' +
                    '</tbody>' +
                    '</table>' +
                    '</div>' +
                    '<div class="modal-footer">' +
                    '<div class="form-group" ng-if="selectedItem">' +
                    '<div class="col-sm-12 selected-user" ng-if="selectedItem">Assign to {{selectedItem.first_name}} {{selectedItem.last_name}} ({{selectedItem.email}})</div>' +
                    '</div>' +
                    '<button class="btn btn-primary" ng-click="ok()" ng-disabled="!enableAssignTask">OK</button>' +
                    '<button class="btn btn-warning" ng-click="cancel()">Cancel</button>' +
                    '</div>'
                );
                elem.append(modal);
                return modal;
            }

            function submitUser() {
                var modal = angular.element(
                    '<div class="modal-header">' +
                    '<h3 class="modal-title">{{title}}</h3>' +
                    '</div>' +
                    '<div class="modal-body">' +
                    '<div class="input-group col-sm-10">' +
                    '<select class="form-control" ng-model="selectedItem" ng-options="user as user.first_name + \' \' + user.last_name for user in users">' +
                    '</select>' +
                    '</div>' +
                    '<br/><br/>' +
                    '<div class="form-group" ng-if="selectedItem">' +
                    '<div class="col-sm-10">' +
                    'Set {{selectedItem.first_name}} {{selectedItem.last_name}} ({{selectedItem.email}}) as the submit user?' +
                    '</div>' +
                    '</div>' +
                    '</div>' +
                    '<div class="modal-footer">' +
                    '<button class="btn btn-primary" ng-click="ok()">OK</button>' +
                    '<button class="btn btn-warning" ng-click="cancel()">Cancel</button>' +
                    '</div>');
                elem.append(modal);
                return modal;
            }

            function cancelReason() {
                var modal = angular.element(
                    '<form name="cr">' +
                    '<div class="modal-header">' +
                    '<h3 class="modal-title">{{title}}</h3>' +
                    '</div>' +
                    '<div class="modal-body">' +
                    'Select a Cancellation Reason:' +
                    '<div class="form-group">' +
                    '<div class="col-sm-10">' +
                    '<select required class="form-control" ng-model="cancelReason" ng-options="cancelreason.id as cancelreason.name  for cancelreason in cancelReasons"><option></option>' +
                    '</select>' +
                    '</div>' +
                    '</div>' +
                    '<br/><br/><br><br>Additional Information:' +
                    '<div class="form-group" >' +
                    '<div class="col-sm-10">' +
                    '<textarea class="form-control"  ng-model="cancelReasonText"></textarea>' +
                    '</div>' +
                    '</div>' +
                    '</div><br><br>' +
                    '<div class="modal-footer">' +
                    '<button class="btn btn-primary" ng-click="cr.$valid && ok()">OK</button>' +
                    '<button class="btn btn-warning" ng-click="cancel()">Cancel</button>' +
                    '</div></form>');
                elem.append(modal);
                return modal;
            }

            function taskTimelog() {
                var modal = angular.element(
                    '<div class="modal-header">' +
                    '<h3 class="modal-title">Time Logged for this Task</h3>' +
                    '</div>' +
                    '<div class="modal-body"><div class="container-fluid">' +
                    '<div class="form-group" ng-repeat="timelog in taskAssignmentTimelog">' +
                    '<div class="col-sm-10">' +
                    '{{timelog.logged_time | minutesToTime}} {{timelog.first_name}} {{timelog.last_name}} ({{timelog.created_at}}) <a ng-click="delete(timelog.id, timelog.task_assignment_id)"> delete</a>' +
                    '</div>' +
                    '</div>' +
                    '</div></div>' +
                    '<div class="modal-footer">' +
                    '<button class="btn btn-warning" ng-click="ok()">Close</button>' +
                    '</div>');
                elem.append(modal);
                return modal;
            }

            function exceptionLogs() {
                var modal = angular.element(
                    '<div class="modal-header">' +
                    '<h3 class="modal-title"> Logs: {{day}} </h3>' +
                    '</div>' +
                    '<div class="page">' +
                    '<div class="order-table table-responsive" ng-if="tableReady && !viewEntry">' +
                    '<table legacy-datatable class="display" cellspacing="0" dt-options="dtOptions"></table>' +
                    '</div>' +
                    '<div ng-if="viewEntry" style="padding:16px;">' +
                    '{{entry}}' +
                    '</div>' +
                    '</div>' +
                    '<div class="modal-footer">' +
                    '<button class="btn btn-danger" ng-if="viewEntry" ng-click="closeEntry()">Back</button>' +
                    '<button class="btn btn-warning" ng-click="closeModal()">Close</button>' +
                    '</div>');
                elem.append(modal);
                return modal;
            }

            function commonLog() {
                var modal = angular.element(
                    '<div class="modal-header">' +
                    '<h3 class="modal-title">{{title}}</h3>' +
                    '</div>' +
                    '<div class="modal-body"><div class="container-fluid">' +
                    '<div class="form-group">' +
                    '<div class="col-sm-10">' +
                    '{{logEntry}}' +
                    '</div>' +
                    '</div>' +
                    '</div></div>' +
                    '<div class="modal-footer">' +
                    '<button class="btn btn-warning" ng-click="ok()">Close</button>' +
                    '</div>');
                elem.append(modal);
                return modal;
            }

            // TODO: Moved to new page, Remove after testing TO-688
            function salesforceConnectionForm() {
                var modal = angular.element(
                    '<div class="modal-header">' +
                    '<h3 class="modal-title">Enter Credentials</h3>' +
                    '</div>' +
                    '<form class="form-horizontal" name="salesforceForm" novalidate>' +
                    '<div class="modal-body">' +
                    '<div class="form-group">' +
                    '<label class="col-sm-4 control-label">Client Token</label>' +
                    '<div class="col-sm-8">' +
                    '<input type="text" class="form-control" ng-model="saleforceObj.clientToken">' +
                    '</div>' +
                    '</div>' +
                    '<div class="form-group">' +
                    '<label class="col-sm-4 control-label">Client Token Secret</label>' +
                    '<div class="col-sm-8">' +
                    '<input type="text" class="form-control" ng-model="saleforceObj.clientTokenSecret">' +
                    '</div>' +
                    '</div>' +
                    '<div class="form-group">' +
                    '<label class="col-sm-4 control-label required">URL</label>' +
                    '<div class="col-sm-8">' +
                    '<input type="text" class="form-control" ng-model="saleforceObj.url">' +
                    '</div>' +
                    '</div>' +
                    '<div class="form-group">' +
                    '<label class="col-sm-4 control-label required">Username</label>' +
                    '<div class="col-sm-8">' +
                    '<input type="text" class="form-control" ng-model="saleforceObj.user_name" ng-required="true">' +
                    '</div>' +
                    '</div>' +
                    '<div class="form-group">' +
                    '<label class="col-sm-4 control-label required">Password</label>' +
                    '<div class="col-sm-8">' +
                    '<input type="text" class="form-control" ng-model="saleforceObj.password" ng-required="true">' +
                    '</div>' +
                    '</div>' +
                    '<div class="form-group">' +
                    '<label class="col-sm-4 control-label">Security Token</label>' +
                    '<div class="col-sm-8">' +
                    '<input type="text" class="form-control" ng-model="saleforceObj.security_token">' +
                    '</div>' +
                    '</div>' +
                    '</div>' +
                    '<div class="modal-footer">' +
                    '<button class="btn btn-primary" ng-click="saveSalesforceConnection(salesforceForm)">Save</button>' +
                    '<button class="btn btn-danger" ng-click="cancelSalesforce(salesforceForm)">Cancel</button>' +
                    '</div>' +
                    '</form>');
                elem.append(modal);
                return modal;
            }

            function integrationForm() {
                var modal = angular.element(
                    '<div class="modal-header">' +
                    '<h3 class="modal-title">{{integrationHeader}}</h3>' +
                    '</div>' +
                    '<form class="form-horizontal" name="integrationForm" novalidate>' +
                    '<div class="modal-body">' +
                    '<div class="form-group">' +
                    '<label class="col-sm-4 control-label required">Name</label>' +
                    '<div class="col-sm-8">' +
                    '<input type="text" class="form-control ng-pristine ng-empty ng-invalid ng-invalid-required ng-touched" ng-model="name" ng-required="true" required="required">' +
                    '</div>' +
                    '</div>' +
                    '<div ng-if="isSalesforceModel || showClientOnlyCb" class="form-group">' +
                    '<label class="col-sm-4 control-label">Import client data only</label>' +
                    '<div class="col-sm-8">' +
                    '<input type="checkbox" class="" ng-model="salesObj.clientOnly"/>' +
                    '</div>' +
                    '</div>' +
                    '<div ng-if="isWebhookModel" class="form-group">' +
                    '<label class="col-sm-4 control-label">Type</label>' +
                    '<div class="col-sm-8">' +
                    '<select class="form-control" ng-model="webhookObj.typeId" ng-options="opt.id as opt.label for opt in webhookTypes" required></select>' +
                    '</div>' +
                    '</div>' +
                    '</div>' +
                    '<div class="modal-footer">' +
                    '<button class="btn btn-primary" ng-disabled="!name" ng-click="addOrUpdateIntegration(integrationForm)">Save</button>' +
                    '<button class="btn btn-danger" ng-click="cancel(integrationForm)">Cancel</button>' +
                    '</div>' +
                    '</form>');
                elem.append(modal);
                return modal;
            }

            /*function fileIntegrationForm() {
                var modal = angular.element(
                    '<div class="modal-header">' +
                    '<h3 class="modal-title" ng-if="fromIntegrations">Create new Integration</h3>' +
                    '<h3 class="modal-title" ng-if="!fromIntegrations">Update</h3>' +
                    '</div>' +
                    '<form class="form-horizontal file-integration-modal" name="integrationForm" novalidate>' +
                    '<div class="modal-body">' +
                    '<div class="form-group" ng-if="fromIntegrations">' +
                    '<label class="col-sm-4 control-label required">Name</label>' +
                    '<div class="col-sm-8">' +
                    '<input type="text" class="form-control ng-pristine ng-empty ng-invalid ng-invalid-required ng-touched" ng-model="nameObj.name" ng-required="true" required="required">' +
                    '</div>' +
                    '</div>' +
                    '</div>' +
                    '<div class="form-group full">' +
                    '<label class="col-sm-4 control-label required">Delivery type <span class="icomoon-help has-tooltip ml5" title="" data-placement="top" data-original-title="Select the source from which the application should retrieve the data files on a periodic/nightly basis or when &quot;Update Dashboard&quot; is selected. You will enter the actual credentials in the next step through Connect Data Sources."></span></label>' +
                    '<div class="col-sm-8">' +
                    '<div class="btn-group btn-group-sm" data-toggle="buttons">' +
                    '<label ng-repeat="authType in authTypes" class="btn btn-default" ng-class="{active: formObj.auth_type == authType}" ng-click="formObj.auth_type = authType;">' +
                    '<input type="radio" ng-required="true"> <span><!----> <!----> {{authType}}</span></label>' +
                    '</div>' +
                    '</div>' +
                    '</div>' +
                    '<div class="row" ng-if="authView == \'basic\'">' +
                    '<div class="col-sm-6">' +
                    '<div class="form-group file-forms">' +
                    '<label class="col-sm-4 control-label required">Host</label>' +
                    '<div class="col-sm-8">' +
                    '<input type="text" class="form-control" ng-model="formObj.host" ng-required="true">' +
                    '</div>' +
                    '</div>' +
                    '<div class="form-group file-forms">' +
                    '<label class="col-sm-4 control-label required">User Name</label>' +
                    '<div class="col-sm-8">' +
                    '<input type="text" class="form-control" ng-model="formObj.username" ng-required="true">' +
                    '</div>' +
                    '</div>' +
                    '<div class="form-group file-forms">' +
                    '<label class="col-sm-4 control-label required">Password</label>' +
                    '<div class="col-sm-8">' +
                    '<input type="password" class="form-control" ng-model="formObj.password" ng-required="true">' +
                    '</div>' +
                    '</div>' +
                    '</div>' +
                    '<div class="col-sm-6">' +
                    '<div class="form-group file-forms">' +
                    '<label class="col-sm-4 control-label required">Data File Directory</label>' +
                    '<div class="col-sm-8">' +
                    '<input type="text" class="form-control" ng-model="formObj.fileDirectory" ng-required="true">' +
                    '</div>' +
                    '</div>' +
                    '<div class="form-group file-forms">' +
                    '<label class="col-sm-4 control-label required">Data File Name</label>' +
                    '<div class="col-sm-8">' +
                    '<input type="text" class="form-control" ng-model="formObj.fileName" ng-required="true">' +
                    '</div>' +
                    '</div>' +
                    '<div class="form-group file-forms">' +
                    '<label class="col-sm-4 control-label required">Email</label>' +
                    '<div class="col-sm-8">' +
                    '<input type="text" class="form-control" ng-model="formObj.email" ng-required="true">' +
                    '</div>' +
                    '</div>' +
                    '</div>' +
                    '</div>' +
                    '<div class="row text-center" ng-if="authView == \'GoogleDrive\'">' +
                    '<a class="btn btn-primary" lk-google-picker on-picked="onPicked(docs)" on-loaded="onLoaded()" on-cancel="onCancel()">Open my Google Drive</a>' +
                    '</div>' +
                    '<div class="modal-footer">' +
                    '<button class="btn btn-primary" ng-if="!fromIntegrations" ng-click="addOrUpdateIntegration(integrationForm, false)">Save</button>' +
                    '<button class="btn btn-primary" ng-if="fromIntegrations" ng-click="addOrUpdateIntegration(integrationForm, true)">Save</button>' +
                    '<button class="btn btn-danger" ng-click="cancel(integrationForm)">Cancel</button>' +
                    '</div>' +
                    '</form>');
                elem.append(modal);
                return modal;
            }*/

            function addMapping() {
                var modal = angular.element(
                    '<div class="modal-header">' +
                    '<h3 class="modal-title">Create {{integration.name}} Mapping</h3>' +
                    '<h6 ng-show="isLoading">Loading...</h6>' +
                    '</div>' +
                    '<form class="form-horizontal" name="mappingForm" novalidate>' +
                    '<div class="modal-body">' +
                    '<div class="form-group">' +
                    '<label class="col-sm-4 control-label required">Mapping Type</label>' +
                    '<div class="col-sm-8">' +
                    '<select class="form-control" ng-model="mappingObj.integrationTypeId" ng-options="key as value for (key, value) in mappingTypes" required ng-change="pickMapping(mappingObj.integrationTypeId)"></option>' +
                    '<option value="">Select...</option>' +
                    '</select>' +
                    '</div>' +
                    '</div>' +
                    '</hr>' +
                    '<div ng-show="mappingObj.integrationTypeId && mappingObj.integrationTypeId != 3">' +
                    '<div class="form-group">' +
                    '<label class="col-sm-4 control-label required">{{(mappingTypes[mappingObj.integrationTypeId]|lowercase) == "product" ? "Incoming Product Identifier" : "Incoming Business Unit" }}</label>' +
                    '<div class="col-sm-8">' +
                    '<input type="text" class="form-control"  ng-model="mappingObj.xrefKey" ng-required="true" required="required">' +
                    '</div>' +
                    '</div>' +
                    '<div class="form-group">' +
                    '<label class="col-sm-4 control-label required">{{(mappingTypes[mappingObj.integrationTypeId]|lowercase) == "product" ? "Product" : "Business Unit" }}</label>' +
                    '<div class="col-sm-8">' +
                    '<select class="form-control" ng-model="mappingObj.xrefValue" ng-options="xref.id as xref.name for xref in xrefArr" ng-required="true" required="required"></option>' +
                    '<option value="">Select...</option>' +
                    '</select>' +
                    '</div>' +
                    '</div>' +
                    '<div ng-show="mappingObj.integrationTypeId && mappingObj.integrationTypeId == 2" class="form-group">' +
                    '<label class="col-sm-4 control-label">Default Order Mapping</label>' +
                    '<div class="col-sm-8">' +
                    '<input type="checkbox" ng-model="mappingObj.isDefault"/>' +
                    '</div>' +
                    '</div>' +
                    '</div>' +
                    '</div>' +
                    '<div class="modal-footer">' +
                    '<button class="btn btn-primary" ng-if="isClientType" ng-click="addMapping(mappingForm, true)">Save</button>' +
                    '<button class="btn btn-primary" ng-if="!isClientType" ng-disabled="!mappingObj.xrefValue || !mappingObj.integrationTypeId || !mappingObj.xrefKey" ng-click="addMapping(mappingForm, false)">Save</button>' +
                    '<button class="btn btn-danger" ng-click="cancel()">Cancel</button>' +
                    '</div>' +
                    '</form>');
                elem.append(modal);
                return modal;
            }

            function deleteMapping() {
                var modal = angular.element(
                    '<div class="modal-header">' +
                    '<h3 class="modal-title">Delete Mapping</h3>' +
                    '</div>' +
                    '<form class="form-horizontal" name="mappingForm">' +
                    '<div class="modal-body">' +
                    '<div class="form-group">' +
                    '<h4 class="col-sm-12 control-label" style="text-align: center;">Warning, deleting mapping.</h4>' +
                    '</div>' +
                    '</div>' +
                    '<div class="modal-footer">' +
                    '<button class="btn btn-primary" ng-click="deleteMapping()">Delete Mapping</button>' +
                    '<button class="btn btn-danger" ng-click="cancel()">Cancel</button>' +
                    '</div>' +
                    '</form>');
                elem.append(modal);
                return modal;
            }

            function deleteIntegration() {
                var modal = angular.element(
                    '<div class="modal-header">' +
                    '<h3 class="modal-title">Delete Integration</h3>' +
                    '</div>' +
                    '<form class="form-horizontal" name="mappingForm">' +
                    '<div class="modal-body">' +
                    '<div class="form-group">' +
                    '<h4 class="col-sm-12 control-label" style="text-align: center;">Warning, deleting integration.</h4>' +
                    '</div>' +
                    '</div>' +
                    '<div class="modal-footer">' +
                    '<button class="btn btn-primary" ng-click="deleteMapping()">Delete Integration</button>' +
                    '<button class="btn btn-danger" ng-click="cancel()">Cancel</button>' +
                    '</div>' +
                    '</form>');
                elem.append(modal);
                return modal;
            }

            function inventoryEvents() {
                var modal = angular.element(
                    '<div class="modal-header">' +
                    '<h3 class="modal-title"> {{property.text}}: {{day}} </h3>' +
                    '</div>' +
                    '<div class="page">' +
                    '<div class="order-table table-responsive booked-slots-table" ng-if="tableReady">' +
                    '<table legacy-datatable class="display" cellspacing="0" dt-options="dtOptions"></table>' +
                    '</div>' +
                    '</div>' +
                    '<div class="modal-footer">' +
                    '<button class="btn btn-warning" ng-click="closeModal()">Close</button>' +
                    '</div>');
                elem.append(modal);
                return modal;
            }

            function inventoryReservedEvents() {
                var modal = angular.element(
                    '<div class="modal-header">' +
                    '<h3 class="modal-title"> {{property.text}}: {{day}} </h3>' +
                    '</div>' +
                    '<div class="page">' +
                    '<div class="order-table table-responsive booked-slots-table" ng-if="tableReady">' +
                    '<table legacy-datatable class="display" cellspacing="0" dt-options="dtOptions"></table>' +
                    '</div>' +
                    '</div>' +
                    '<div class="modal-footer">' +
                    '<button class="btn btn-warning" ng-click="closeModal()">Close</button>' +
                    '</div>');
                elem.append(modal);
                return modal;
            }

            function nightlyStatus() {
                var modal = angular.element(
                    '<div class="modal-header">' +
                    '<h3 class="modal-title"> Logs: {{day}} </h3>' +
                    '</div>' +
                    '<div class="page">' +
                    '<div class="order-table table-responsive" ng-if="!tableReady">' + 
                    '<h4 style="margin-left: 100px">{{loadingMessage}}</h4></div>' +
                    '<div class="order-table table-responsive" ng-if="tableReady">' +
                    '<table legacy-datatable class="display" cellspacing="0" dt-options="dtOptions"></table>' +
                    '</div>' +
                    '</div>' +
                    '<div class="modal-footer">' +
                    '<button class="btn btn-warning" ng-click="closeModal()">Close</button>' +
                    '</div>');
                elem.append(modal);
                return modal;
            }

            function notifications() {
                var modal = angular.element(
                    '<div>' +
                    '<div class="modal-header">' +
                    '<button type="button" class="close" ng-click="cancel()"><span aria-hidden="true">&times;</span></button>' +
                    '<h3 class="modal-title">Notification Info &nbsp;&nbsp; <small ng-if="loadingMessage">Loading ... </small></h3>' +
                    '</div>' +
                    '<div class="modal-body">' +
                    '<form class="form-horizontal">' +
                    '<div class="form-group">' +
                    '<label class="col-sm-2 control-label"></label>' +
                    '<div class="col-sm-10">' +
                    '{{notification.message}}' +
                    '<br>' +
                    '<div ng-if="additionalInfoOne != \'\'" ng-bind-html="additionalInfoOne"><br></div>' +
                    '<div ng-if="additionalInfoTwo != \'\'" ng-bind-html="additionalInfoTwo">{{additionalInfoTwo}}<br/></div>' +
                    '<div ng-if="additionalInfoThree != \'\'" ng-bind-html="additionalInfoThree">{{additionalInfoThree}}<br/></div>' +
                    '<div ng-show="isTask">' +
                    '<div ng-if="additionalInfoFour != \'\'" ng-bind-html="additionalInfoFour">{{additionalInfoFour}}<br></div>' +
                    '<div ng-if="additionalInfoFive != \'\'" ng-bind-html="additionalInfoFive">{{additionalInfoFive}}<br></div>' +
                    '<div ng-if="additionalInfoSix != \'\'" ng-bind-html="additionalInfoSix">{{additionalInfoSix}}<br></div>' +
                    '</div>' +
                    '</div>' +
                    '</div>' +
                    '<div class="form-group">' +
                    '<label class="col-sm-2 control-label"></label>' +
                    '<div class="col-sm-10">' +
                    '<p class="form-control-static">' +
                    '<a ng-click="open($index)" ng-show="!isViewDisabled" >View {{notification.type}}</a>' +
                    '</p>' +
                    '</div>' +
                    '</div>' +
                    '</form>' +
                    '</div>' +
                    '<div class="modal-footer">' +
                    '<button class="btn btn-info" ng-if="!archived" ng-click="archive()">Archive</button>' +
                    '<button class="btn btn-warning" ng-click="cancel()">Close</button>' +
                    '</div>' +
                    '</div>');
                elem.append(modal);
                return modal;
            }

            function reporting() {
                var modal = angular.element(
                    '<div class="modal-header">' +
                    '<h3 class="modal-title">New Template</h3>' +
                    '</div>' +
                    '<form class="form-horizontal" name="templateForm">' +
                    '<div class="modal-body">' +
                    '<div class="form-group">' +
                    '<label class="col-sm-4 control-label required">Template Name</label>' +
                    '<div class="col-sm-8">' +
                    '<input type="text" class="form-control" ng-model="templateObj.name">' +
                    '</div>' +
                    '</div>' +
                    '</div>' +
                    '<div class="modal-footer">' +
                    '<button class="btn btn-primary" ng-click="addTemplate(templateForm)">OK</button>' +
                    '<button class="btn btn-warning" ng-click="cancel()">Cancel</button>' +
                    '</div>' +
                    '</form>');
                elem.append(modal);
                return modal;
            }

            function updateHideConditionForm() {
                var modal = angular.element(
                    '<div class="modal-header">' +
                    '<h3 class="modal-title">{{headerTitle}}</h3>' +
                    '</div>' +
                    '<form class="form-horizontal" name="groupForm">' +
                    '<div class="modal-body">' +
                    '<div class="form-group">' +
                    '<label class="col-sm-4 control-label">Property Name</label>' +
                    '<div class="col-sm-8">' +
                    '<div class="input-group">' +
                    '<select class="form-control" ng-model="conditionObj.hideForConditionType" ng-change="selectCondtionType()" ng-options="tpye for tpye in conditionObj.hideConditionTypes"></select>' +
                    '<span class="input-group-btn cluster-clear">' +
                    '<button ng-click="clearHideCondition()" class="btn btn-warning btn-sm">' +
                    '<b>X</b>' +
                    '</button>' +
                    '</span>' +
                    '</div>' +
                    '</div>' +
                    '</div>' +
                    '<div class="form-group">' +
                    '<label class="col-sm-4 control-label">Property Value</label>' +
                    '<div class="col-sm-8">' +
                    '<ui-select ui-select-no-animate multiple ng-model="conditionObj.hideForCondition" theme="bootstrap" ng-disabled="disabled" sortable="true" close-on-select="true" style="width: 80%;">' +
                    '<ui-select-match placeholder="Select type values..." class="ui-select-match">{{$item.name}}</ui-select-match>' +
                    '<ui-select-choices class="ui-select-choices-list" repeat="value.id as value in conditionObj.hideConditionValues | propsFilter: {name: $select.search}" class="ui-select-choices">' +
                    '<div ng-bind-html="value.name | highlight: $select.search"></div>' +
                    '</ui-select-choices>' +
                    '</ui-select>' +
                    '</div>' +
                    '</div>' +
                    '</div>' +
                    '<div class="modal-footer">' +
                    '<button class="btn btn-primary" ng-click="addHideCondition(groupForm)">OK</button>' +
                    '<button class="btn btn-warning" ng-click="cancel()">Cancel</button>' +
                    '</div>' +
                    '</form>');
                elem.append(modal);
                return modal;
            }
            function addFormLookupContent() {
                var modal = angular.element(
                    '<div class="modal-header">' +
                    '<h3 class="modal-title"></h3>' +
                    '</div>' +
                    '<form class="form-horizontal" name="lookupContentForm">' +
                    '<div class="modal-body">' +
                    '<div class="form-group">' +
                    '<label class="col-sm-3 control-label">Form Id</label>' +
                    '<div class="col-sm-9">' +
                    '<input type="text" class="form-control" ng-model="formContentObj.formId" ng-disabled="true">' +
                    '</div>' +
                    '</div>' +
                    '<div class="form-group">' +
                    '<label class="col-sm-3 control-label">Lookup Content</label>' +
                    '<div class="col-sm-9">' +
                    '<div class="input-group">' +
                    '<ui-select ui-select-no-animate multiple ng-model="formContentObj.lookupContents" theme="bootstrap" ng-disabled="disabled" sortable="true" close-on-select="false">' +
                    '<ui-select-match placeholder="Select content..." class="ui-select-match">{{$item.lookup_value}}</ui-select-match>' +
                    '<ui-select-choices class="ui-select-choices-list" repeat="attrib in lookupAttributes | propsFilter: {lookup_value: $select.search}" class="ui-select-choices">' +
                    '<div ng-bind-html="attrib.lookup_value | highlight: $select.search"></div>' +
                    '</ui-select-choices>' +
                    '</ui-select>' +
                    '<span class="input-group-btn">' +
                    '<button ng-click="formContentObj.lookupContents = undefined" class="btn btn-warning btn-sm">' +
                    '<b>X</b>' +
                    '</button>' +
                    '</span>' +
                    '</div>' +
                    '<a ng-click="selectAllContents();" class="btn btn-success btn-sm io-btn-small">' +
                    'Select All' +
                    '</a>' +
                    '</div>' +
                    '</div>' +
                    '</div>' +
                    '<div class="modal-footer">' +
                    '<button class="btn btn-primary" ng-click="addFormContent(lookupContentForm)">OK</button>' +
                    '<button class="btn btn-warning" ng-click="cancel()">Cancel</button>' +
                    '</div>' +
                    '</form>');
                elem.append(modal);
                return modal;
            }

            function cloneFormLookupContent() {
                var modal = angular.element(
                    '<div class="modal-header">' +
                    '<h3 class="modal-title">Clone Form Lookup Content</h3>' +
                    '</div>' +
                    '<form class="form-horizontal" name="cloneForm">' +
                    '<div class="form-group custom-form-group">' +
                    '<label class="col-sm-4 control-label">Destination Business Unit(s)</label>' +
                    '<div class="col-sm-8">' +
                    '<div class="input-group ui-select-input-field custom-input-clone">' +
                    '<ui-select ui-select-no-animate multiple ng-model="cloneObj.destClusterIds" theme="bootstrap" sortable="true" class="form-control" close-on-select="false" tagging="tagHandler" style="max-width:61%;">' +
                    '<ui-select-match placeholder="Select one or more Business Unit...">{{$item.name}}</ui-select-match>' +
                    '<ui-select-choices class="ui-select-choices-list" repeat="opt.id as opt in clusterArr | propsFilter: {name: $select.search}" position="down">' +
                    '<div ng-bind-html="opt.name | highlight: $select.search"></div>' +
                    '</ui-select-choices>' +
                    '</ui-select>' +
                    '<span class="input-group-btn cluster-clear-clone">' +
                    '<button ng-click="cloneObj.destClusterIds = undefined" class="btn btn-warning btn-sm">' +
                    '<b>X</b>' +
                    '</button>' +
                    '</span>' +
                    '</div>' +
                    '<a ng-click="selectAllClusters();" class="btn btn-success btn-sm io-btn-small">' +
                    'Select All' +
                    '</a>' +
                    '</div>' +
                    '</div>' +
                    '</div>' +
                    '<div class="form-group">' +
                    '<label class="col-sm-4 control-label">Content Type</label>' +
                    '<div class="col-sm-8">' +
                    '<div class="input-group ui-select-input-field">' +
                    '<ui-select ui-select-no-animate multiple ng-model="cloneObj.lookupTypeIds" theme="bootstrap" sortable="true" class="form-control" close-on-select="false" tagging="tagHandler" style="max-width:50%;">' +
                    '<ui-select-match placeholder="Select one or more Content types...">{{$item.name}}</ui-select-match>' +
                    '<ui-select-choices class="ui-select-choices-list" repeat="opt.id as opt in contentTypes | propsFilter: {name: $select.search}" position="down">' +
                    '<div ng-bind-html="opt.name | highlight: $select.search"></div>' +
                    '</ui-select-choices>' +
                    '</ui-select>' +
                    '<span class="input-group-btn cluster-clear">' +
                    '<button ng-click="cloneObj.lookupTypeIds = undefined" class="btn btn-warning btn-sm">' +
                    '<b>X</b>' +
                    '</button>' +
                    '</span>' +
                    '</div>' +
                    '<a ng-click="selectAllContentTypes();" class="btn btn-success btn-sm io-btn-small">' +
                    'Select All' +
                    '</a>' +
                    '</div>' +
                    '</div>' +
                    '</div>' +
                    '<div class="form-group">' +
                    '<label class="col-sm-4 control-label">Destination Form(s)</label>' +
                    '<div class="col-sm-8">' +
                    '<div class="input-group ui-select-input-field">' +
                    '<ui-select ui-select-no-animate multiple ng-model="cloneObj.destFormIds" theme="bootstrap" sortable="true" class="form-control" close-on-select="false" tagging="tagHandler" style="max-width:50%;">' +
                    '<ui-select-match placeholder="Select one or more Forms...">{{$item.name}}</ui-select-match>' +
                    '<ui-select-choices class="ui-select-choices-list" repeat="opt.id as opt in formList | propsFilter: {name: $select.search}" position="down">' +
                    '<div ng-bind-html="opt.name | highlight: $select.search"></div>' +
                    '</ui-select-choices>' +
                    '</ui-select>' +
                    '<span class="input-group-btn cluster-clear">' +
                    '<button ng-click="cloneObj.destFormIds = undefined" class="btn btn-warning btn-sm">' +
                    '<b>X</b>' +
                    '</button>' +
                    '</span>' +
                    '</div>' +
                    '<a ng-click="selectAllForms();" class="btn btn-success btn-sm io-btn-small">' +
                    'Select All' +
                    '</a>' +
                    '</div>' +
                    '</div>' +
                    '</div>' +
                    '<div class="modal-footer">' +
                    '<button class="btn btn-primary" ng-click="cloneContent(cloneForm)">OK</button>' +
                    '<button class="btn btn-warning" ng-click="cancel()">Cancel</button>' +
                    '</div>' +
                    '</form>');
                elem.append(modal);
                return modal;
            }

            function deleteLookupContent() {
                var modal = angular.element(
                    '<div class="modal-header">' +
                    '<h3 class="modal-title">Delete Lookup Content</h3>' +
                    '</div>' +
                    '<form class="form-horizontal">' +
                    '<div class="modal-body">' +
                    '<div class="form-group">' +
                    '<h4 class="col-sm-12 control-label" style="text-align: center;">Warning! You are attempting to delete or clear content for a Lookup Type.</h4>' +
                    '</div>' +
                    '</div>' +
                    '<div class="modal-footer">' +
                    '<button class="btn btn-primary" ng-click="delete()">Delete</button>' +
                    '<button class="btn btn-danger" ng-click="cancel()">Cancel</button>' +
                    '</div>' +
                    '</form>');
                elem.append(modal);
                return modal;
            }

            function createLookupContent() {
                var modal = angular.element(
                    '<div class="modal-header">' +
                    '<h3 class="modal-title">{{lookupText}}</h3>' +
                    '</div>' +
                    '<form class="form-horizontal" name="lookupForm">' +
                    '<div class="modal-body">' +
                    '<div class="form-group">' +
                    '<label class="col-sm-4 control-label required">Lookup Value</label>' +
                    '<div class="col-sm-8">' +
                    '<input type="text" class="form-control" ng-model="lookupObj.lookupValue" ng-required="true" autofocus>' +
                    '</div>' +
                    '</div>' +
                    '<div class="form-group" ng-if="lookupObj.parentContentKeySourceNames">' +
                    '<label class="col-sm-4 control-label required">Parent Lookup Value</label>' +
                    '<div class="col-sm-8">' +
                    '<select class="form-control" ng-model="lookupObj.parent_content_key_source_name" ng-required="true" ng-options="opt for opt in lookupObj.parentContentKeySourceNames"></select>' +
                    '</div>' +
                    '</div>' +
                    '</div>' +
                    '<div class="modal-footer">' +
                    '<button class="btn btn-primary" ng-click="addLookupContent(lookupForm)">OK</button>' +
                    '<button class="btn btn-warning" ng-click="cancel()">Cancel</button>' +
                    '</div>' +
                    '</form>');
                elem.append(modal);
                return modal;
            }

            function createLookupType() {
                var modal = angular.element(
                    '<div class="modal-header">' +
                    '<h3 class="modal-title">{{lookupText}}</h3>' +
                    '</div>' +
                    '<form class="form-horizontal" name="lookupForm">' +
                    '<div class="modal-body">' +
                    '<div class="form-group">' +
                    '<label class="col-sm-4 control-label required">Name</label>' +
                    '<div class="col-sm-8">' +
                    '<input type="text" class="form-control" ng-model="lookupObj.name" ng-required="true">' +
                    '</div>' +
                    '</div>' +
                    '<div class="form-group">' +
                    '<label class="col-sm-4 control-label">Content key</label>' +
                    '<div class="col-sm-8">' +
                    '<select class="form-control pull-left" ng-model="lookupObj.content_key" ng-options="opt for opt in lookupContentKeys"></select>' +
                    '<span class="input-group-btn close-btn">' +
                    '<button ng-click="lookupObj.content_key = undefined" class="btn btn-warning btn-sm">' +
                    '<b>X</b>' +
                    '</button>' +
                    '</span>' +
                    '</div>' +
                    '</div>' +
                    '<div class="form-group">' +
                    '<label class="col-sm-4 control-label">Parent</label>' +
                    '<div class="col-sm-8">' +
                    '<select class="form-control pull-left" ng-model="lookupObj.parent_lookup_type_name" ng-options="opt for opt in lookupTypeIdNames"></select>' +
                    '<span class="input-group-btn close-btn">' +
                    '<button ng-click="lookupObj.parent_lookup_type_name = undefined" class="btn btn-warning btn-sm">' +
                    '<b>X</b>' +
                    '</button>' +
                    '</span>' +
                    '</div>' +
                    '</div>' +
                    '</div>' +
                    '<div class="modal-footer">' +
                    '<button class="btn btn-primary" ng-click="addLookupType(lookupForm)">OK</button>' +
                    '<button class="btn btn-warning" ng-click="cancel()">Cancel</button>' +
                    '</div>' +
                    '</form>');
                elem.append(modal);
                return modal;
            }

            function deleteCreative() {
                var modal = angular.element(
                    '<div class="modal-header creative-delete">' +
                    '<h3 class="modal-title">Are you sure you want to delete {{filename}}?<span class="line"></span></h3>' +
                    '</div>' +
                    '<div class="modal-footer">' +
                    '<button class="btn btn-primary" ng-click="confirm()">Ok</button>' +
                    '<button class="btn btn-danger" ng-click="cancel()">Cancel</button>' +
                    '</div>');
                elem.append(modal);
                return modal;
            }

            function deletePixel() {
                var modal = angular.element(
                    '<div class="modal-header creative-delete">' +
                    '<h3 class="modal-title">This "{{pixelname}}" tracker is associated with lineitem(s) and removing will cause it to stop tracking conversions. Are you sure you want to continue?<span class="line"></span></h3>' +
                    '</div>' +
                    '<div class="modal-footer">' +
                    '<button class="btn btn-primary" ng-click="confirm()">Ok</button>' +
                    '<button class="btn btn-danger" ng-click="cancel()">Cancel</button>' +
                    '</div>');
                elem.append(modal);
                return modal;
            }

            function lineItemChanges() {
                var modal = angular.element(
                    '<div class="modal-header">' +
                    '<h3 class="modal-title">Changes</h3>' +
                    '</div>' +
                    '<div class="modal-body auditLog-modal">' +
                    '<table class="table">' +
                    '<tr>' +
                    '<th>Before</th>' +
                    '<th>After</th>' +
                    '<th>Modified Date</th>' +
                    '<th>Updated By</th>' +
                    '</tr>' +
                    '<tr ng-repeat="list in changesList">' +
                    '<td class="break-word" ng-if="!list.beforeIsHtml">{{list.before}}</td>' +
                    '<td class="break-word" ng-if="list.beforeIsHtml" ng-bind-html="list.before"></td>' +
                    '<td class="break-word" ng-if="!list.afterIsHtml">{{list.after}}</td>' +
                    '<td class="break-word" ng-if="list.afterIsHtml" ng-bind-html="list.after"></td>' +
                    '<td>{{list.date}}</td>' +
                    '<td>{{list.userName}}</td>' +
                    '</tr>' +
                    '</table>' +
                    '</div>' +
                    '<div class="modal-footer">' +
                    '<button class="btn btn-primary" type="button" ng-click="ok()">OK</button>' +
                    '<button class="btn btn-warning" type="button" ng-click="cancel()">Cancel</button>' +
                    '</div>');
                elem.append(modal);
                return modal;
            }

            function flightChanges() {
                var modal = angular.element(
                    '<div class="modal-header">' +
                    '<h3 class="modal-title">Changes</h3>' +
                    '</div>' +
                    '<div class="modal-body auditLog-modal">' +
                    '<table class="table">' +
                    '<tr>' +
                    '<th>Before</th>' +
                    '<th>After</th>' +
                    '<th>Modified Date</th>' +
                    '<th>Updated By</th>' +
                    '</tr>' +
                    '<tr ng-repeat="list in changesList">' +
                    '<td class="break-word" ng-if="!list.beforeIsHtml">{{list.before}}</td>' +
                    '<td class="break-word" ng-if="list.beforeIsHtml" ng-bind-html="list.before"></td>' +
                    '<td class="break-word" ng-if="!list.afterIsHtml">{{list.after}}</td>' +
                    '<td class="break-word" ng-if="list.afterIsHtml" ng-bind-html="list.after"></td>' +
                    '<td>{{list.date}}</td>' +
                    '<td>{{list.userName}}</td>' +
                    '</tr>' +
                    '</table>' +
                    '</div>' +
                    '<div class="modal-footer">' +
                    '<button class="btn btn-primary" type="button" ng-click="ok()">OK</button>' +
                    '<button class="btn btn-warning" type="button" ng-click="cancel()">Cancel</button>' +
                    '</div>');
                elem.append(modal);
                return modal;
            }

            function moveFlight() {
                var modal = angular.element(
                    '<div class="modal-header">' +
                    '<h3 class="modal-title">Move {{moreThanOneFlight ? "Flights" : "Flight"}}</h3>' +
                    '</div>' +
                    '<form class="form-horizontal" name="moveFlightForm">' +
                    '<div class="modal-body">' +
                    '<div class="form-group">' +
                    '<label class="col-sm-4 control-label required">Destination Line Item</label>' +
                    '<div class="col-sm-8">' +
                    '<select class="form-control" ng-model="flightObj.selectedLineItem" ng-options="lineItem.id as lineItem.name for lineItem in flightObj.lineItemList" ng-required="true"></select>' +
                    '</div>' +
                    '</div>' +
                    '<div class="form-group">' +
                    '<label class="col-sm-4 control-label">New Flight Status</label>' +
                    '<div class="col-sm-8">' +
                    '<select class="form-control" ng-model="flightObj.selectedStatusId" ng-options="flightStatus.id as flightStatus.name for flightStatus in flightObj.flightStatusList"></select>' +
                    '</div>' +
                    '</div>' +
                    '<div class="form-group" ng-if="flightObj.flightWorkflowSteps && flightObj.flightWorkflowSteps.length > 0">' +
                    '<label class="col-sm-4 control-label">New Flight Workflow Step</label>' +
                    '<div class="col-sm-8">' +
                    '<select class="form-control" ng-model="flightObj.selectedWorkflowStepId" ng-options="workflowStep.id as workflowStep.name for workflowStep in flightObj.flightWorkflowSteps"></select>' +
                    '</div>' +
                    '</div>' +
                    '<div class="form-group">' +
                    '<label class="col-sm-4 control-label">Workflow Action to Send to Flight Workflow</label>' +
                    '<div class="col-sm-8">' +
                    '<select class="form-control" ng-model="flightObj.selectedWorkflowAction" ng-options="workflowAction.id as workflowAction.name for workflowAction in flightObj.workflowActions"></select>' +
                    '</div>' +
                    '</div>' +
                    '</div>' +
                    '<div class="modal-footer">' +
                    '<button class="btn btn-primary" ng-click="ok()">OK</button>' +
                    '<button class="btn btn-warning" ng-click="cancel()">Cancel</button>' +
                    '</div>' +
                    '</form>');
                elem.append(modal);
                return modal;
            }

            function autoCreateFlights() {
                let modal = angular.element(
                    '<div style="overflow-x: auto">' +
                    '<div class="modal-header">' +
                    '<h3 class="modal-title">{{ isRegenerate ? \'Regenerate\' : \'Auto-Create\' }} Flights Preview</h3>' +
                    '<p ng-if="isRegenerate"><br><strong>Warning!</strong> The following flights will be deleted, please confirm:</p>' +
                    '<p ng-if="!isRegenerate"><br>The following flights will be created, please confirm:</p>' +
                    '</div>' +
                    '<form class="form-horizontal" name="autoCreateFlightsForm">' +
                    '<div class="modal-body">' +
                    '<div class="form-group" ng-if="isRegenerate">' +
                    '<table class="dataTable table table-striped" id="deleted-flights-table">'+
                    '<thead>' +
                    '<tr>' +
                    '<th className="sorting_disabled" ng-repeat="header in deletedFlightHeaders">{{header.display_name}}</th>' +
                    '</tr>' +
                    '</thead>' +
                    '<tbody>' +
                    '<tr ng-repeat="flight in deletedFlights">' +
                    '<td ng-repeat="header in deletedFlightHeaders">{{flight[header.field_name]}}</td>' +
                    '</tr>' +
                    '</tbody>' +
                    '</table>' +
                    '</div>' +
                    '<div class="form-group">' +
                    '<div class="modal-header" ng-if="isRegenerate"><p><br>The following flights will be created instead:</p></div>' +
                    '<table class="dataTable table table-striped" id="auto-create-flights-table">'+
                    '<thead>' +
                    '<tr>' +
                    '<th className="sorting_disabled" ng-repeat="header in autoCreatedFlightHeaders">{{header.display_name}}</th>' +
                    '</tr>' +
                    '</thead>' +
                    '<tbody>' +
                    '<tr ng-repeat="flight in autoCreatedFlights">' +
                    '<td ng-repeat="header in autoCreatedFlightHeaders">{{flight[header.field_name]}}</td>' +
                    '</tr>' +
                    '</tbody>' +
                    '</table>' +
                    '</div>' +
                    '<div class="form-group" ng-if="hasExistingFlights">' +
                    '<div class="modal-header" ng-if="!hasOverriddenValues"><p>Existing flights:</p></div>' +
                    '<div class="modal-header" ng-if="hasOverriddenValues"><p>Existing flights: (* indicates value is overridden or flight is Complete)</p></div>' +
                    '<table class="dataTable table table-striped" id="auto-create-flights-table">'+
                    '<thead>' +
                    '<tr>' +
                    '<th className="sorting_disabled" ng-repeat="header in existingFlightHeaders">{{header.display_name}}</th>' +
                    '</tr>' +
                    '</thead>' +
                    '<tbody>' +
                    '<tr ng-repeat="flight in existingFlights">' +
                    '<td ng-repeat="header in existingFlightHeaders">{{flight[header.field_name]}}</td>' +
                    '</tr>' +
                    '</tbody>' +
                    '</table>' +
                    '</div>' +
                    '</div>' +
                    '<div class="modal-footer">' +
                    '<button class="btn btn-primary" ng-click="ok()">{{ isRegenerate ? \'Regenerate\' : \'Create\' }} Flights</button>' +
                    '<button class="btn btn-warning" ng-click="cancel()">Cancel</button>' +
                    '</div>' +
                    '</form>' +
                    '</div>');
                elem.append(modal);
                return modal;
            }

            function showFormulaErrors() {
                let modal = angular.element(
                    '<div style="overflow-x: auto">' +
                    '<div class="modal-header">' +
                    '<h3 class="modal-title">Formula Errors</h3>' +
                    '<p><br><strong>Warning!</strong> Some calculated fields in this form have formula errors:</p>' +
                    '</div>' +
                    '<form class="form-horizontal" name="showFormulaErrorsForm">' +
                    '<div class="modal-body">' +
                    '<div class="form-group">' +
                    '<table class="dataTable table table-striped" id="show-formula-errors-table">'+
                    '<thead>' +
                    '<tr>' +
                    '<th className="sorting_disabled">Field Id</th>' +
                    '<th className="sorting_disabled">Field Name</th>' +
                    '<th className="sorting_disabled">Formula</th>' +
                    '<th className="sorting_disabled">Error (if any)</th>' +
                    '</tr>' +
                    '</thead>' +
                    '<tbody>' +
                    '<tr ng-repeat="formulaRow in formulaErrors">' +
                    '<td style="background: {{(formulaRow.error == \'\') ? \'#d8fad1\' : \'#ffbab8\'}}">{{formulaRow.id}}</td>' +
                    '<td style="background: {{(formulaRow.error == \'\') ? \'#d8fad1\' : \'#ffbab8\'}}">{{formulaRow.name}}</td>' +
                    '<td style="background: {{(formulaRow.error == \'\') ? \'#d8fad1\' : \'#ffbab8\'}}">{{formulaRow.formula}}</td>' +
                    '<td style="background: {{(formulaRow.error == \'\') ? \'#d8fad1\' : \'#ffbab8\'}}">{{formulaRow.error}}</td>' +
                    '</tr>' +
                    '</tbody>' +
                    '</table>' +
                    '</div>' +
                    '</div>' +
                    '<div class="modal-footer">' +
                    '<button class="btn btn-primary" ng-click="ok()">OK</button>' +
                    '</div>' +
                    '</form>' +
                    '</div>');
                elem.append(modal);
                return modal;
            }

            function redistributeValues() {
                let modal = angular.element(
                    '<div style="overflow-x: auto">' +
                    '<div class="modal-header">' +
                    '<h3 class="modal-title">Redistribute Values Preview</h3>' +
                    '<p><br>The following flights will be updated as follows (modified values in <b>bold</b> type), please confirm:</p>' +
                    '<p ng-if="hasOverriddenValues">(* indicates value is overridden or flight\'s status is Complete)</p>' +
                    '</div>' +
                    '<form class="form-horizontal" name="redistributeValuesForm">' +
                    '<div class="modal-body">' +
                    '<div class="form-group">' +
                    '<table class="dataTable table table-striped" id="redistribute-values-table">'+
                    '<thead>' +
                    '<tr>' +
                    '<th className="sorting_disabled" ng-repeat="header in existingFlightHeaders">{{header.display_name}}</th>' +
                    '</tr>' +
                    '</thead>' +
                    '<tbody>' +
                    '<tr ng-repeat="flight in existingFlights">' +
                    '<td ng-repeat="header in existingFlightHeaders" style="font-weight:{{flight[header.field_name + \'__font_weight__\']}}">{{flight[header.field_name]}}</td>' +
                    '</tr>' +
                    '</tbody>' +
                    '</table>' +
                    '</div>' +
                    '</div>' +
                    '<div class="modal-footer">' +
                    '<button class="btn btn-primary" ng-click="ok()">Confirm</button>' +
                    '<button class="btn btn-warning" ng-click="cancel()">Cancel</button>' +
                    '</div>' +
                    '</form>' +
                    '</div>');
                elem.append(modal);
                return modal;
            }

            function addRoutingRuleSet() {
                var modal = angular.element(
                    '<div class="modal-header">' +
                    '<h3 class="modal-title">{{ruleSetText}}</h3>' +
                    '</div>' +
                    '<form class="form-horizontal ruleSetForm" name="ruleSetForm">' +
                    '<div class="modal-body">' +
                    '<div class="form-group">' +
                    '<label class="col-sm-4 control-label required">Workflow Action</label>' +
                    '<div class="col-sm-8">' +
                    '<select class="form-control" ng-model="ruleSetObj.workflowActionId" ng-options="opt.id as opt.name for opt in actionsArr" ng-required="true"></select>' +
                    '</div>' +
                    '</div>' +
                    '<div class="form-group">' +
                    '<label class="col-sm-4 control-label">Status</label>' +

                    '<div class="col-sm-8 input-group ui-select-input-field close-btn-wrapper">' +
                    '<ui-select ui-select-no-animate multiple ng-model="ruleSetObj.statusIds" theme="bootstrap" sortable="true" class="form-control" close-on-select="false" tagging="tagHandler" style="max-width:50%;">' +
                    '<ui-select-match placeholder="Select one or more statuses...">{{$item.name}}</ui-select-match>' +
                    '<ui-select-choices class="ui-select-choices-list" repeat="opt.id as opt in statusArr | propsFilter: {name: $select.search}" position="down">' +
                    '<div ng-bind-html="opt.name | highlight: $select.search"></div>' +
                    '</ui-select-choices>' +
                    '</ui-select>' +
                    '<span class="input-group-btn cluster-clear">' +
                    '<button ng-click="ruleSetObj.statusIds = undefined" class="btn btn-warning btn-sm">' +
                    '<b>X</b>' +
                    '</button>' +
                    '</span>' +
                    '</div>' +

                    // '<div class="col-sm-8 input-group close-btn-wrapper">' +
                    // '<select class="form-control" ng-model="ruleSetObj.statusId" ng-options="opt.id as opt.name for opt in statusArr"></select>' +
                    // '<span class="input-group-btn close-btn">' +
                    // '<button ng-click="ruleSetObj.statusId = undefined" class="btn btn-warning btn-sm">' +
                    // '<b>X</b>' +
                    // '</button>' +
                    // '</span>' +
                    // '</div>' +

                    '</div>' +
                    '<div class="form-group">' +
                    '<label class="col-sm-4 control-label">Default Reset</label>' +
                    '<div class="col-sm-8">' +
                    '<input type="checkbox" ng-model="ruleSetObj.isDefault">' +
                    '</div>' +
                    '</div>' +
                    '</div>' +
                    '<div class="modal-footer">' +
                    '<button class="btn btn-danger pull-left" ng-if="!isNew" ng-click="deleteRuleSet(ruleSetObj.id)">Delete</button>' +
                    '<button class="btn btn-primary" ng-click="addRuleSet(ruleSetForm)">OK</button>' +
                    '<button class="btn btn-warning" ng-click="cancel()">Cancel</button>' +
                    '</div>' +
                    '</form>');
                elem.append(modal);
                return modal;
            }

            function addRuleSet() {
                var modal = angular.element(
                    '<div class="modal-header">' +
                    '<h3 class="modal-title">{{ruleSetText}}</h3>' +
                    '</div>' +
                    '<form class="form-horizontal" name="ruleSetForm">' +
                    '<div class="modal-body">' +
                    '<div class="form-group">' +
                    '<label class="col-sm-4 control-label required">Name</label>' +
                    '<div class="col-sm-8">' +
                    '<input type="text" class="form-control" ng-model="ruleSetObj.name" ng-required="true">' +
                    '</div>' +
                    '</div>' +
                    '</div>' +
                    '<div class="modal-footer">' +
                    '<button class="btn btn-primary" ng-click="addRuleSet(ruleSetForm)">OK</button>' +
                    '<button class="btn btn-warning" ng-click="cancel()">Cancel</button>' +
                    '</div>' +
                    '</form>');
                elem.append(modal);
                return modal;
            }

            function createWorkflow() {
                var modal = angular.element(
                    '<div class="modal-header">' +
                    '<h3 class="modal-title">{{workflowText}}</h3>' +
                    '</div>' +
                    '<form class="form-horizontal" name="workflowForm">' +
                    '<div class="modal-body">' +
                    '<div class="form-group">' +
                    '<label class="col-sm-4 control-label required">Name</label>' +
                    '<div class="col-sm-8">' +
                    '<input type="text" class="form-control" ng-model="workflowObj.name" ng-required="true">' +
                    '</div>' +
                    '</div>' +
                    '<div class="form-group">' +
                    '<label class="col-sm-4 control-label required">Type Id</label>' +
                    '<div class="col-sm-8">' +
                    '<select class="form-control" ng-model="workflowObj.typeId" ng-disabled="workflowObj.typeDisabled" ng-options="opt.id as opt.name for opt in typeArr" ng-required="true" ng-change="toggleWorkflow(workflowObj.typeId)">' +
                    '</select>' +
                    '</div>' +
                    '</div>' +
                    '<div ng-if="workflowObj.typeId==\'2\' || workflowObj.typeId==\'4\'">' +
                    '<div class="form-group">' +
                    '<label class="col-sm-4 control-label required">Product Id</label>' +
                    '<div class="col-sm-8">' +
                    '<select class="form-control" ng-change="productOrTypeSelected(workflowObj.productId, workflowObj.typeId)" ng-model="workflowObj.productId" ng-options="opt.id as opt.name for opt in productArr" ng-required="true">' +
                    '</select>' +
                    '</div>' +
                    '</div>' +
                    '</div>' +
                    '<div ng-if="workflowObj.typeId==\'1\' || workflowObj.typeId==\'3\'">' +
                    '<div class="form-group custom-form-group">' +
                    '<label class="col-sm-4 control-label">Business Unit</label>' +
                    '<div class="col-sm-8">' +
                    '<div class="input-group ui-select-input-field custom-input-size">' +
                    '<ui-select ui-select-no-animate multiple ng-model="workflowObj.clusterIds" on-remove="handleOnRemoval(workflowObj.clusterIds)" on-select="handleOnSelection(workflowObj.clusterIds)" theme="bootstrap" sortable="true" class="form-control" close-on-select="false" tagging="tagHandler" style="max-width:55%;">' +
                    '<ui-select-match placeholder="Select one or more business units...">{{$item.name}}</ui-select-match>' +
                    '<ui-select-choices class="ui-select-choices-list" repeat="opt.id as opt in clusterArr | propsFilter: {name: $select.search}" position="down">' +
                    '<div ng-bind-html="opt.name | highlight: $select.search"></div>' +
                    '</ui-select-choices>' +
                    '</ui-select>' +
                    '<span class="input-group-btn cluster-clear-custom">' +
                    '<button ng-click="workflowObj.clusterIds = undefined" class="btn btn-warning btn-sm">' +
                    '<b>X</b>' +
                    '</button>' +
                    '</span>' +
                    '</div>' +
                    '</div>' +
                    '</div>' +
                    '<div class="form-group">' +
                    '<label ng-if="workflowObj.typeId==\'1\'" class="col-sm-4 control-label">Default Order Workflow</label>' +
                    '<label ng-if="workflowObj.typeId==\'3\'" class="col-sm-4 control-label">Default Client Workflow</label>' +
                    '<div class="col-sm-8">' +
                    '<input type="checkbox" ng-model="workflowObj.isDefault">' +
                    '</div>' +
                    '</div>' +
                    '</div>' +
                    '<div class="form-group">' +
                    '<label class="col-sm-4 control-label">Active</label>' +
                    '<div class="col-sm-8">' +
                    '<input type="checkbox" ng-model="workflowObj.active">' +
                    '</div>' +
                    '</div>' +
                    '<div class="form-group">' +
                    '<label class="col-sm-4 control-label required">Initial Status Id</label>' +
                    '<div class="col-sm-8">' +
                    '<select class="form-control" ng-model="workflowObj.initialStatusId" ng-options="opt.id as opt.name for opt in statusArr" ng-required="true">' +
                    '</select>' +
                    '</div>' +
                    '</div>' +
                    '</div>' +
                    '<div class="form-group">' +
                    '<label class="col-sm-4 control-label">Workflow Step Policy</label>' +
                    '<div class="col-sm-8">' +
                    '<select class="pull-left form-control" ng-change="getGroupSteps(workflowObj.workflowStepGroupId)" ng-model="workflowObj.workflowStepGroupId" ng-change="initialStep()" ng-options="opt.id as opt.name for opt in stepGroups"></select>' +
                    '<span class="input-group-btn close-btn"><button ng-click="workflowObj.workflowStepGroupId = undefined; workflowObj.initialStepId = undefined;" class="btn btn-warning btn-sm"><b>X</b></button></span>' +
                    '</div>' +
                    '</div>' +
                    '<div class="form-group">' +
                    '<label class="col-sm-4 control-label">initial workflow step</label>' +
                    '<div class="col-sm-8">' +
                    '<select class="form-control" ng-model="workflowObj.initialStepId" ng-options="opt.workflow_step_id as opt.name for opt in steps"></select>' +
                    '</div>' +
                    '</div>' +
                    '<div class="modal-footer">' +
                    '<button class="btn btn-primary" ng-click="addWorkflow(workflowForm)">OK</button>' +
                    '<button class="btn btn-warning" ng-click="cancel()">Cancel</button>' +
                    '</div>' +
                    '</form>');
                elem.append(modal);
                return modal;
            }

            function createRoutingRule() {
                var modal = angular.element(
                    '<div class="modal-header">' +
                    '<h3 class="modal-title">{{routingText}}</h3>' +
                    '</div>' +
                    '<form class="form-horizontal" name="routingRuleForm">' +
                    '<div class="modal-body">' +
                    '<div class="form-group">' +
                    '<label class="col-sm-4 control-label required">Routing Rule Set ID</label>' +
                    '<div class="col-sm-8">' +
                    '<input type="text" class="form-control" ng-model="routingRuleObj.routingRuleSetId" ng-required="true" ng-disabled="true">' +
                    '</div>' +
                    '</div>' +
                    '<div class="form-group">' +
                    '<label class="col-sm-4 control-label">Status ID</label>' +
                    '<div class="col-sm-8">' +
                    '<select class="form-control" style="float : left;" ng-model="routingRuleObj.statusId" ng-options="opt.id as opt.name for opt in statusArr"></select>' +
                    '<span class="input-group-btn close-btn">' +
                    '<button ng-click="routingRuleObj.statusId = undefined" class="btn btn-warning btn-sm">' +
                    '<b>X</b>' +
                    '</button>' +
                    '</span>' +
                    '</div>' +
                    '</div>' +
                    '<div class="form-group">' +
                    '<label class="col-sm-4 control-label">Workflow Step</label>' +
                    '<div class="col-sm-8">' +
                    '<select class="pull-left form-control" ng-model="routingRuleObj.workflowStepId" ng-options="opt.workflow_step_id as opt.name for opt in steps"></select>' +
                    '<span class="input-group-btn close-btn">' +
                    '<button ng-click="routingRuleObj.workflowStepId = undefined" class="btn btn-warning btn-sm">' +
                    '<b>X</b>' +
                    '</button>' +
                    '</span>' +
                    '</div>' +
                    '</div>' +
                    '<div class="form-group">' +
                    '<label class="col-sm-4 control-label">Default Rule</label>' +
                    '<div class="col-sm-8">' +
                    '<input type="checkbox" ng-model="routingRuleObj.defaultRule">' +
                    '</div>' +
                    '</div>' +
                    '<div class="form-group" ng-if="showAuxiliaryActionUp">' +
                    '<label class="col-sm-4 control-label">{{auxiliaryActionUpText}}</label>' +
                    '<div class="col-sm-8">' +
                    '<select class="form-control" style="float : left;" ng-model="routingRuleObj.auxiliaryActionUp" ng-options="opt.id as opt.name for opt in actionsArr"></select>' +
                    '<span class="input-group-btn close-btn">' +
                    '<button ng-click="routingRuleObj.auxiliaryActionUp = undefined" class="btn btn-warning btn-sm">' +
                    '<b>X</b>' +
                    '</button>' +
                    '</span>' +
                    '</div>' +
                    '</div>' +
                    '<div class="form-group" ng-if="showAuxiliaryActionDown">' +
                    '<label class="col-sm-4 control-label">{{auxiliaryActionDownText}}</label>' +
                    '<div class="col-sm-8">' +
                    '<select class="form-control" style="float : left;" ng-model="routingRuleObj.auxiliaryActionDown" ng-options="opt.id as opt.name for opt in actionsArr"></select>' +
                    '<span class="input-group-btn close-btn">' +
                    '<button ng-click="routingRuleObj.auxiliaryActionDown = undefined" class="btn btn-warning btn-sm">' +
                    '<b>X</b>' +
                    '</button>' +
                    '</span>' +
                    '</div>' +
                    '</div>' +
                    '</div>' +
                    '<div class="form-group">' +
                    '<label class="col-sm-4 control-label">Function</label>' +
                    '<div class="col-sm-8">' +
                    '<select class="pull-left form-control" ng-model="routingRuleObj.runFunction" ng-options="opt for opt in functionsArr"></select>' +
                    '<span class="input-group-btn close-btn">' +
                    '<button ng-click="routingRuleObj.runFunction = undefined" class="btn btn-warning btn-sm">' +
                    '<b>X</b>' +
                    '</button>' +
                    '</span>' +
                    '</div>' +
                    '</div>' +
                    '<div class="modal-footer">' +
                    '<button class="btn btn-danger pull-left" ng-if="!isNew" ng-click="deleteRoutingRule(routingRuleObj.id)">Delete</button>' +
                    '<button class="btn btn-primary" ng-click="addRoutingRule(routingRuleForm)">OK</button>' +
                    '<button class="btn btn-warning" ng-click="cancel()">Cancel</button>' +
                    '</div>' +
                    '</form>');
                elem.append(modal);
                return modal;
            }

            function createRoutingCondition() {
                var modal = angular.element(
                    '<div class="modal-header">' +
                    '<h3 class="modal-title">{{conditionText}}</h3>' +
                    '</div>' +
                    '<form class="form-horizontal" name="routingConditionForm">' +
                    '<div class="modal-body">' +
                    '<div class="form-group">' +
                    '<label class="col-sm-4 control-label required">Routing Rule Set ID</label>' +
                    '<div class="col-sm-8">' +
                    '<input type="text" class="form-control" ng-model="routingConditionObj.routingRuleSetId" ng-required="true" ng-disabled="true">' +
                    '</div>' +
                    '</div>' +
                    '<div class="form-group">' +
                    '<label class="col-sm-4 control-label required">Rule Set Name</label>' +
                    '<div class="col-sm-8">' +
                    '<select class="form-control" ng-model="routingConditionObj.ruleSetId" ng-options="opt.id as opt.name + \' -- #\' + opt.id for opt in tapIORuleSetsArr" ng-required="true"></select>' +
                    '</div>' +
                    '</div>' +
                    '<div class="form-group">' +
                    '<label class="col-sm-4 control-label required">True Routing Rule ID</label>' +
                    '<div class="col-sm-8">' +
                    '<select class="form-control" ng-model="routingConditionObj.trueRoutingRuleId" ng-options="opt.id as opt.id for opt in routingRulesArr" ng-required="true"></select>' +
                    '</div>' +
                    '</div>' +
                    '<div class="form-group">' +
                    '<label class="col-sm-4 control-label">False Routing Rule ID</label>' +
                    '<div class="col-sm-8">' +
                    '<select class="form-control" ng-model="routingConditionObj.falseRoutingRuleId" ng-options="opt.id as opt.id for opt in routingRulesArr"></select>' +
                    '</div>' +
                    '</div>' +
                    '</div>' +
                    '<div class="modal-footer">' +
                    '<button class="btn btn-danger pull-left" ng-if="!isNew" ng-click="deleteRoutingCondition(routingConditionObj.id)">Delete</button>' +
                    '<button class="btn btn-primary" ng-click="addRoutingCondition(routingConditionForm)">OK</button>' +
                    '<button class="btn btn-warning" ng-click="cancel()">Cancel</button>' +
                    '</div>' +
                    '</form>');
                elem.append(modal);
                return modal;
            }

            function createWorkflowTask() {
                var modal = angular.element(
                    '<div class="modal-header">' +
                    '<h3 class="modal-title">{{taskText}}</h3>' +
                    '</div>' +
                    '<form class="form-horizontal" name="workflowForm">' +
                    '<div class="modal-body">' +
                    '<div class="form-group">' +
                    '<label class="col-sm-4 control-label required">Workflow Action ID</label>' +
                    '<div class="col-sm-8">' +
                    '<select class="form-control" ng-model="taskObj.workflowActionId" ng-required="true" ng-options="opt.id as opt.name for opt in actionArr"></select>' +
                    '</div>' +
                    '</div>' +
                    '<div class="form-group">' +
                    '<label class="col-sm-4 control-label required">Routing Rule ID</label>' +
                    '<div class="col-sm-8">' +
                    '<input type="text" class="form-control" ng-model="taskObj.routingRuleId" ng-disabled="isRoutingRuleId">' +
                    '</div>' +
                    '</div>' +
                    '<div class="form-group">' +
                    '<label class="col-sm-4 control-label required">Task</label>' +
                    '<div class="col-sm-8">' +
                    '<select class="form-control" ng-model="taskObj.taskId" ng-options="opt.id as opt.name for opt in tasksList" ng-required="true"></select>' +
                    '</div>' +
                    '</div>' +
                    '<div class="form-group">' +
                    '<label class="col-sm-4 control-label">On-demand</label>' +
                    '<div class="col-sm-1">' +
                    '<input type="checkbox" class="work-flow-checkbox" ng-model="taskObj.onDemand" />' +
                    '</div>' +
                    '</div>' +
                    '<div class="form-group">' +
                    '<label class="col-sm-4 control-label">Shared</label>' +
                    '<div class="col-sm-1">' +
                    '<input type="checkbox" class="work-flow-checkbox" id="shaded" ng-model="taskObj.shared" ng-change="toggleUnifyShared()"/>' +
                    '</div>' +
                    '</div>' +
                    '<div class="form-group">' +
                    '<label class="col-sm-4 control-label">Link with other shared tasks of the same type</label>' +
                    '<div class="col-sm-1 shared-tasks">' +
                    '<input type="checkbox" class="work-flow-checkbox" ng-disabled="unifySharedDisabled" ng-model="taskObj.unifyShared" />' +
                    '</div>' +
                    '</div>' +
                    '<div class="form-group">' +
                    '<label class="col-sm-4 control-label">Enable asynchronous processing for integrations</label>' +
                    '<div class="col-sm-1">' +
                    '<input type="checkbox" class="work-flow-checkbox" ng-model="taskObj.asynchronous" />' +
                    '</div>' +
                    '</div>' +
                    '<div class="form-group">' +
                    '<label class="col-sm-4 control-label required">Sequence</label>' +
                    '<div class="col-sm-8">' +
                    '<input type="number" class="form-control numText" ng-model="taskObj.sequence" ng-required="true">' +
                    '</div>' +
                    '</div>' +
                    '<div class="form-group">' +
                    '<label class="col-sm-4 control-label">Auto Assign</label>' +
                    '<div class="col-sm-8">' +
                    '<input type="text" class="form-control" ng-model="taskObj.autoAssign">' +
                    '</div>' +
                    '</div>' +
                    '</div>' +
                    '<div class="modal-footer">' +
                    '<button class="btn btn-danger pull-left" ng-if="!isNew" ng-click="deleteTask(taskObj.id)">Delete</button>' +
                    '<button class="btn btn-primary" ng-click="addTask(workflowForm)">OK</button>' +
                    '<button class="btn btn-warning" ng-click="cancel()">Cancel</button>' +
                    '</div>' +
                    '</form>');
                elem.append(modal);
                return modal;
            }

            function createWorkflowTaskInterlocking() {
                var modal = angular.element(
                    '<div class="modal-header">' +
                    '<h3 class="modal-title">{{interlockingText}}</h3>' +
                    '</div>' +
                    '<form class="form-horizontal" name="workflowTaskInterlockingForm">' +
                    '<div class="modal-body">' +
                    '<div class="form-group">' +
                    '<label class="col-sm-4 control-label required">Workflow Action ID</label>' +
                    '<div class="col-sm-8">' +
                    '<select class="form-control" ng-model="interlockingObj.workflowActionId" ng-required="true" ng-options="opt.id as opt.name for opt in actionArr"></select>' +
                    '</div>' +
                    '</div>' +
                    '<div class="form-group">' +
                    '<label class="col-sm-4 control-label required">Condition</label>' +
                    '<div class="col-sm-8">' +
                    '<select class="form-control" ng-model="interlockingObj.condition" ng-required="true">' +
                    '<option value="AND">AND</option>' +
                    '<option value="OR">OR</option>' +
                    '</select>' +
                    '</div>' +
                    '</div>' +
                    '<div class="form-group">' +
                    '<label class="col-sm-4 control-label required">Workflow Tasks</label>' +
                    '<div class="col-sm-8">' +
                    '<div ng-repeat="workflowTask in workflowTasks">' +
                    '<span ng-show="workflowTask.routing_rule_id==interlockingObj.routingRuleId">' +
                    '<input type="checkbox" ng-model="workflowTaskIds[workflowTask.id]" ' +
                        'ng-click="selectWorkflowTaskForInterlockingTaskRule(workflowTask.id)"/> ' +
                        '{{workflowTask.definition}} ({{workflowTask.name}})' +
                    '</span>' +
                    '</div>' +
                    '</div>' +
                    '</div>' +
                    '</div>' +
                    '<div class="modal-footer">' +
                    '<button class="btn btn-danger pull-left" ng-if="!isNew" ng-click="deleteLock()">Delete</button>' +
                    '<button class="btn btn-primary" ng-click="addInterlocking(workflowTaskInterlockingForm)">OK</button>' +
                    '<button class="btn btn-warning" ng-click="cancel()">Cancel</button>' +
                    '</div>' +
                    '</form>');
                elem.append(modal);
                return modal;
            }

            function createWorkflowAction() {
                var modal = angular.element(
                    '<div class="modal-header">' +
                    '<h3 class="modal-title">{{workflowActionText}}</h3>' +
                    '</div>' +
                    '<form class="form-horizontal" name="workflowActionForm">' +
                    '<div class="modal-body">' +
                    '<div class="form-group">' +
                    '<label class="col-sm-4 control-label required">Name</label>' +
                    '<div class="col-sm-8">' +
                    '<input type="text" class="form-control" ng-model="workflowActionObj.name" ng-required="true">' +
                    '</div>' +
                    '</div>' +
                    '<div class="form-group" ng-show="workflowActionObj.mutable == 1">' +
                    '<label class="col-sm-4 control-label">Active</label>' +
                    '<div class="col-sm-8">' +
                    '<input type="checkbox" ng-model="workflowActionObj.active">' +
                    '</div>' +
                    '</div>' +
                    '<div class="form-group" ng-show="workflowActionObj.mutable == 1">' +
                    '<label class="col-sm-4 control-label">Custom Edit Action</label>' +
                    '<div class="col-sm-8">' +
                    '<input type="checkbox" ng-model="workflowActionObj.custom_edit">' +
                    '</div>' +
                    '</div>' +
                    '<div class="form-group">' +
                    '<label class="col-sm-4 control-label">Sequence</label>' +
                    '<div class="col-sm-8">' +
                    '<input type="number" class="form-control numText" ng-model="workflowActionObj.sequence">' +
                    '</div>' +
                    '</div>' +
                    '</div>' +
                    '<div class="modal-footer">' +
                    '<button class="btn btn-primary" ng-click="addOrEditWorkflowAction(workflowActionForm)">OK</button>' +
                    '<button class="btn btn-warning" ng-click="cancel()">Cancel</button>' +
                    '</div>' +
                    '</form>');
                elem.append(modal);
                return modal;
            }

            function createCustomStatus() {
                var modal = angular.element(
                    '<div class="modal-header">' +
                    '<h3 class="modal-title">{{statusText}}</h3>' +
                    '</div>' +
                    '<form class="form-horizontal" name="statusForm">' +
                    '<div class="modal-body">' +
                    '<div class="form-group">' +
                    '<label class="col-sm-4 control-label required">Name</label>' +
                    '<div class="col-sm-8">' +
                    '<input type="text" class="form-control" ng-model="statusObj.name" ng-required="true">' +
                    '</div>' +
                    '</div>' +
                    '<div class="form-group">' +
                    '<label class="col-sm-4 control-label required">Type</label>' +
                    '<div class="col-sm-8">' +
                    '<select class="form-control" ng-model="statusObj.typeId" ng-options="type.id as type.name for type in statusTypes"></select>' +
                    '</div>' +
                    '</div>' +
                    '<div class="form-group">' +
                    '<label class="col-sm-4 control-label required">Description</label>' +
                    '<div class="col-sm-8">' +
                    '<input type="text" class="form-control" ng-model="statusObj.description" ng-required="true">' +
                    '</div>' +
                    '</div>' +
                    '<div class="form-group">' +
                    '<label class="col-sm-4 control-label">Active</label>' +
                    '<div class="col-sm-8">' +
                    '<input type="checkbox" ng-model="statusObj.active">' +
                    '</div>' +
                    '</div>' +
                    '</div>' +
                    '<div class="modal-footer">' +
                    '<button class="btn btn-primary" ng-click="addOrEditStatus(statusForm)">OK</button>' +
                    '<button class="btn btn-warning" ng-click="cancel()">Cancel</button>' +
                    '</div>' +
                    '</form>');
                elem.append(modal);
                return modal;
            }

            function createCancelReason() {
                var modal = angular.element(
                    '<div class="modal-header">' +
                    '<h3 class="modal-title">{{cancelReasonText}}</h3>' +
                    '</div>' +
                    '<form class="form-horizontal" name="cancelReasonForm">' +
                    '<div class="modal-body">' +
                    '<div class="form-group">' +
                    '<label class="col-sm-4 control-label required">Name</label>' +
                    '<div class="col-sm-8">' +
                    '<input type="text" class="form-control" ng-model="cancelReasonObj.name" ng-required="true">' +
                    '</div>' +
                    '</div>' +
                    '<div class="form-group">' +
                    '<label class="col-sm-4 control-label">Type</label>' +
                    '<div class="col-sm-8">' +
                    '<select ng-disabled="cancelReasonObj.disableType" required class="form-control" ng-model="cancelReasonObj.type" ng-options="cancelreasontype  for cancelreasontype in cancelreasontypes"><option></option>' +
                    '</select>' +
                    '</div>' +
                    '</div>' +
                    '<div class="form-group">' +
                    '<label class="col-sm-4 control-label">Active</label>' +
                    '<div class="col-sm-8">' +
                    '<input type="checkbox" ng-model="cancelReasonObj.active">' +
                    '</div>' +
                    '</div>' +
                    '</div>' +
                    '<div class="modal-footer">' +
                    '<button class="btn btn-primary" ng-click="addOrEditCancelReason(cancelReasonForm)">OK</button>' +
                    '<button class="btn btn-warning" ng-click="cancel()">Cancel</button>' +
                    '</div>' +
                    '</form>');
                elem.append(modal);
                return modal;
            }

            function createProduct() {
                var modal = angular.element(
                    '<div class="modal-header">' +
                    '<h3 class="modal-title">{{headerText}}</h3>' +
                    '</div>' +
                    '<form class="form-horizontal" name="productForm">' +
                    '<div class="modal-body">' +
                    '<div class="form-group custom-form-group">' +
                    '<label class="col-sm-4 control-label required">Business Unit</label>' +
                    '<div class="col-sm-8">' +
                    '<div class="input-group ui-select-input-field custom-input-size">' +
                    '<ui-select ui-select-no-animate ng-required="true" multiple ng-model="productObj.clusterIds" on-remove="handleOnRemoval(productObj.clusterIds)" on-select="handleOnSelection(productObj.clusterIds)" theme="bootstrap" sortable="true" class="form-control" close-on-select="false" tagging="tagHandler" style="max-width:55%;">' +
                    '<ui-select-match placeholder="Select one or more business units...">{{$item.name}}</ui-select-match>' +
                    '<ui-select-choices class="ui-select-choices-list" repeat="opt.id as opt in clusterArr | propsFilter: {name: $select.search}" position="down">' +
                    '<div ng-bind-html="opt.name | highlight: $select.search"></div>' +
                    '</ui-select-choices>' +
                    '</ui-select>' +
                    '<span class="input-group-btn cluster-clear-custom">' +
                    '<button ng-click="productObj.clusterIds = undefined" class="btn btn-warning btn-sm">' +
                    '<b>X</b>' +
                    '</button>' +
                    '</span>' +
                    '</div>' +
                    '</div>' +
                    '</div>' +
                    '<div class="form-group">' +
                    '<label class="col-sm-4 control-label required">Product Name</label>' +
                    '<div class="col-sm-8">' +
                    '<input type="text" class="form-control" ng-model="productObj.name" ng-required="true">' +
                    '</div>' +
                    '</div>' +
                    '<div class="form-group">' +
                    '<label class="col-sm-4 control-label">Product Category</label>' +
                    '<div class="col-sm-8">' +
                    '<select class="form-control" ng-model="productObj.categoryId" ng-options="category.id as category.name for category in productCategories"></select>' +
                    '</div>' +
                    '</div>' +
                    '<div class="form-group">' +
                    '<label class="col-sm-4 control-label required">Order Types</label>' +
                    '<div class="col-sm-8">' +
                    '<ui-select ui-select-no-animate ng-required="true" multiple ng-model="productObj.orderTypeIds" theme="bootstrap" ng-disabled="disabled" sortable="true" close-on-select="true" style="max-width:50%;">' +
                    '<ui-select-match placeholder="Select type values..." class="ui-select-match">{{$item.name}}</ui-select-match>' +
                    '<ui-select-choices class="ui-select-choices-list" repeat="type.id as type in orderTypes | propsFilter: {name: $select.search}" class="ui-select-choices">' +
                    '<div ng-bind-html="type.name | highlight: $select.search"></div>' +
                    '</ui-select-choices>' +
                    '</ui-select>' +
                    '</div>' +
                    '</div>' +
                    '<div class="form-group">' +
                    '<label class="col-sm-4 control-label">Active</label>' +
                    '<div class="col-sm-8">' +
                    '<input type="checkbox" ng-model="productObj.active">' +
                    '</div>' +
                    '</div>' +
                    '<div class="form-group">' +
                    '<label class="col-sm-4 control-label">Bookable</label>' +
                    '<div class="col-sm-8">' +
                    '<input type="checkbox" ng-model="productObj.bookable">' +
                    '</div>' +
                    '</div>' +
                    '<div class="form-group">' +
                    '<label class="col-sm-4 control-label">Uses Flights</label>' +
                    '<div class="col-sm-8">' +
                    '<input type="checkbox" ng-model="productObj.enableFlights">' +
                    '</div>' +
                    '</div>' +
                    '<div class="form-group" ng-if="productObj.enableFlights">' +
                    '<label class="col-sm-4 control-label">Flight Auto-Create Timeframe</label>' +
                    '<div class="col-sm-8">' +
                    '<select class="pull-left form-control" ng-model="productObj.flightAutoCreateTimeframe" ng-options="flightTimeFrame.id as flightTimeFrame.name for flightTimeFrame in flightTimeFrames"></select>' +
                    '<span class="input-group-btn close-btn">' +
                    '<button ng-click="productObj.flightAutoCreateTimeframe = undefined" class="btn btn-warning btn-sm">' +
                    '<b>X</b>' +
                    '</button>' +
                    '</span>' +
                    '</div>' +
                    '</div>' +
                    '<div class="form-group" ng-if="productObj.enableFlights && productObj.flightAutoCreateTimeframe == \'monthly\'">' +
                    '<label class="col-sm-4 control-label">Monthly Flight Start On</label>' +
                    '<div class="col-sm-8">' +
                    '<select class="pull-left form-control" ng-model="productObj.monthlyFlightStartOn" ng-options="startOn.id as startOn.name for startOn in monthlyFlightStartOnValues"></select>' +
                    '<span class="input-group-btn close-btn">' +
                    '<button ng-click="productObj.monthlyFlightStartOn = undefined" class="btn btn-warning btn-sm">' +
                    '<b>X</b>' +
                    '</button>' +
                    '</span>' +
                    '</div>' +
                    '</div>' +
                    '<div class="form-group" ng-if="productObj.enableFlights && productObj.flightAutoCreateTimeframe == \'weekly\'">' +
                    '<label class="col-sm-4 control-label">Weekly Flight Start Day of Week</label>' +
                    '<div class="col-sm-8">' +
                    '<select class="pull-left form-control" ng-model="productObj.weeklyFlightStartOn" ng-options="dayOfWeek.id as dayOfWeek.name for dayOfWeek in weeklyFlightStartDaysOfWeek"></select>' +
                    '<span class="input-group-btn close-btn">' +
                    '<button ng-click="productObj.weeklyFlightStartOn = undefined" class="btn btn-warning btn-sm">' +
                    '<b>X</b>' +
                    '</button>' +
                    '</span>' +
                    '</div>' +
                    '</div>' +
                    '<div class="form-group" ng-if="productObj.enableFlights">' +
                    '<label class="col-sm-4 control-label">Use Flights as Placements</label>' +
                    '<div class="col-sm-8">' +
                    '<input type="checkbox" ng-model="productObj.useFlightsAsPlacements">' +
                    '</div>' +
                    '</div>' +
                    '<div class="form-group">' +
                    '<label class="col-sm-4 control-label">Enable Multiple Mapping</label>' +
                    '<div class="col-sm-8">' +
                    '<input type="checkbox" ng-model="productObj.multipleMapping">' +
                    '</div>' +
                    '</div>' +
                    '<div class="form-group">' +
                    '<label class="col-sm-4 control-label">Legacy Service</label>' +
                    '<div class="col-sm-8">' +
                    '<select class="form-control" ng-model="productObj.serviceId" ng-options="service.id as service.name for service in pushServices"></select>' +
                    '</div>' +
                    '</div>' +
                    '<div class="form-group">' +
                    '<label class="col-sm-4 control-label">Service</label>' +
                    '<div class="col-sm-8">' +
                    '<select class="form-control" ng-model="productObj.taServiceId" ng-options="service.service_id as service.original_name for service in TAServices"></select>' +
                    '</div>' +
                    '</div>' +
                    '</div>' +
                    '<div class="modal-footer">' +
                    '<button class="btn btn-primary" ng-click="addProduct(productForm)">OK</button>' +
                    '<button class="btn btn-warning" ng-click="cancel()">Cancel</button>' +
                    '</div>' +
                    '</form>');
                elem.append(modal);
                return modal;
            }

            function createProductGroup() {
                var modal = angular.element(
                    '<div class="modal-header">' +
                    '<h3 class="modal-title">{{modalTitle}}</h3>' +
                    '</div>' +
                    '<form class="form-horizontal" name="groupForm">' +
                    '<div class="modal-body">' +
                    '<div class="form-group">' +
                    '<label class="col-sm-4 control-label required">Group Name</label>' +
                    '<div class="col-sm-8">' +
                    '<input type="text" class="form-control" ng-model="groupObj.name">' +
                    '</div>' +
                    '</div>' +
                    '</div>' +
                    '<div class="modal-footer">' +
                    '<button class="btn btn-primary" ng-click="addGroup(groupForm)">OK</button>' +
                    '<button class="btn btn-warning" ng-click="cancel()">Cancel</button>' +
                    '</div>' +
                    '</form>');
                elem.append(modal);
                return modal;
            }

            function cloneProduct() {
                var modal = angular.element(
                    '<div class="modal-header">' +
                    '<h3 class="modal-title">Clone Product #{{productId}}</h3>' +
                    '</div>' +
                    '<form class="form-horizontal" name="cloneForm">' +
                    '<div class="modal-body">' +
                    '<div class="form-group">' +
                    '<label class="col-sm-4 control-label required">New Product Name</label>' +
                    '<div class="col-sm-8">' +
                    '<input type="text" class="form-control" ng-model="cloneObj.name">' +
                    '</div>' +
                    '</div>' +
                    '</div>' +
                    '<div class="modal-footer">' +
                    '<button class="btn btn-primary" ng-click="cloneProduct(cloneForm)">OK</button>' +
                    '<button class="btn btn-warning" ng-click="cancel()">Cancel</button>' +
                    '</div>' +
                    '</form>');
                elem.append(modal);
                return modal;
            }
            function cloneForm() {
                var modal = angular.element(
                    '<div class="modal-header">' +
                    '<h3 class="modal-title">Clone Form #{{formId}}</h3>' +
                    '</div>' +
                    '<form class="form-horizontal" name="cloneFormModal">' +
                    '<div class="modal-body">' +
                    '<div class="form-group">' +
                    '<label class="col-sm-4 control-label required">New Form Name</label>' +
                    '<div class="col-sm-8">' +
                    '<input type="text" class="form-control" ng-model="cloneObj.name">' +
                    '</div>' +
                    '</div>' +
                    '</div>' +
                    '<div class="modal-footer">' +
                    '<button class="btn btn-primary" ng-click="cloneForm(cloneFormModal)">OK</button>' +
                    '<button class="btn btn-warning" ng-click="cancel()">Cancel</button>' +
                    '</div>' +
                    '</form>');
                elem.append(modal);
                return modal;
            }
            function updateProductsHideConditionForm() {
                var modal = angular.element(
                    '<div class="modal-header">' +
                    '<h3 class="modal-title">{{headerTitle}}</h3>' +
                    '</div>' +
                    '<form class="form-horizontal" name="groupForm">' +
                    '<div class="modal-body">' +
                    '<div class="form-group">' +
                    '<label class="col-sm-4 control-label">Property Name</label>' +
                    '<div class="col-sm-8">' +
                    '<div class="input-group">' +
                    '<select class="form-control" ng-model="conditionObj.hideForConditionType" ng-change="selectCondtionType()" ng-options="tpye for tpye in conditionObj.hideConditionTypes"></select>' +
                    '<span class="input-group-btn cluster-clear">' +
                    '<button ng-click="clearHideCondition()" class="btn btn-warning btn-sm">' +
                    '<b>X</b>' +
                    '</button>' +
                    '</span>' +
                    '</div>' +
                    '</div>' +
                    '</div>' +
                    '<div class="form-group">' +
                    '<label class="col-sm-4 control-label">Property Value</label>' +
                    '<div class="col-sm-8">' +
                    '<ui-select ui-select-no-animate multiple ng-model="conditionObj.hideForCondition" theme="bootstrap" ng-disabled="disabled" sortable="true" close-on-select="true" style="width: 80%;">' +
                    '<ui-select-match placeholder="Select type values..." class="ui-select-match">{{$item.name}}</ui-select-match>' +
                    '<ui-select-choices class="ui-select-choices-list" repeat="value.id as value in conditionObj.hideConditionValues | propsFilter: {name: $select.search}" class="ui-select-choices">' +
                    '<div ng-bind-html="value.name | highlight: $select.search"></div>' +
                    '</ui-select-choices>' +
                    '</ui-select>' +
                    '</div>' +
                    '</div>' +
                    '</div>' +
                    '<div class="modal-footer">' +
                    '<button class="btn btn-primary" ng-click="addHideCondition(groupForm)">OK</button>' +
                    '<button class="btn btn-warning" ng-click="cancel()">Cancel</button>' +
                    '</div>' +
                    '</form>');
                elem.append(modal);
                return modal;
            }
            function addProductContent() {
                var modal = angular.element(
                    '<div class="modal-header">' +
                    '<h3 class="modal-title"></h3>' +
                    '</div>' +
                    '<form class="form-horizontal" name="productContentForm">' +
                    '<div class="modal-body">' +
                    '<div class="form-group">' +
                    '<label class="col-sm-3 control-label">Product Id</label>' +
                    '<div class="col-sm-9">' +
                    '<input type="text" class="form-control" ng-model="productContentObj.productId" ng-disabled="true">' +
                    '</div>' +
                    '</div>' +
                    '<div class="form-group iotoolselect-width">' +
                    '<label class="col-sm-3 control-label">Lookup Content</label>' +
                    '<div class="col-sm-9">' +
                    '<div class="input-group">' +
                    '<ui-select ui-select-no-animate multiple ng-model="productContentObj.lookupContents" theme="bootstrap" ng-disabled="disabled" sortable="true" close-on-select="false" tagging="tagHandler">' +
                    '<ui-select-match placeholder="Select content...">{{$item.lookup_value}}</ui-select-match>' +
                    '<ui-select-choices class="ui-select-choices-list" repeat="attrib in lookupAttributes | propsFilter: {lookup_value: $select.search}">' +
                    '<div ng-bind-html="attrib.lookup_value | highlight: $select.search"></div>' +
                    '</ui-select-choices>' +
                    '</ui-select>' +
                    '<span class="input-group-btn">' +
                    '<button ng-click="productContentObj.lookupContents = undefined" class="btn btn-warning btn-sm">' +
                    '<b>X</b>' +
                    '</button>' +
                    '</span>' +
                    '</div>' +
                    '<a ng-click="selectAllContents();" class="btn btn-success btn-sm io-btn-small">' +
                    'Select All' +
                    '</a>' +
                    '</div>' +
                    '</div>' +
                    '</div>' +
                    '<div class="modal-footer">' +
                    '<button class="btn btn-primary" ng-click="addProdContent(productContentForm)">OK</button>' +
                    '<button class="btn btn-warning" ng-click="cancel()">Cancel</button>' +
                    '</div>' +
                    '</form>');
                elem.append(modal);
                return modal;
            }

            function lookupContentClone() {
                var modal = angular.element(
                    '<div class="modal-header">' +
                    '<h3 class="modal-title">Clone Lookup Content</h3>' +
                    '</div>' +
                    '<form class="form-horizontal" name="cloneForm">' +
                    '<div class="form-group custom-form-group">' +
                    '<label class="col-sm-4 control-label">Destination Business Unit</label>' +
                    '<div class="col-sm-8">' +
                    '<div class="input-group ui-select-input-field custom-input-clone">' +
                    '<ui-select ui-select-no-animate multiple ng-model="cloneObj.destClusterIds" theme="bootstrap" sortable="true" class="form-control" close-on-select="false" tagging="tagHandler" style="max-width:61%;">' +
                    '<ui-select-match placeholder="Select one or more business units...">{{$item.name}}</ui-select-match>' +
                    '<ui-select-choices class="ui-select-choices-list" repeat="opt.id as opt in clusterArr | propsFilter: {name: $select.search}" position="down">' +
                    '<div ng-bind-html="opt.name | highlight: $select.search"></div>' +
                    '</ui-select-choices>' +
                    '</ui-select>' +
                    '<span class="input-group-btn cluster-clear-clone">' +
                    '<button ng-click="cloneObj.destClusterIds = undefined" class="btn btn-warning btn-sm">' +
                    '<b>X</b>' +
                    '</button>' +
                    '</span>' +
                    '</div>' +
                    '<a ng-click="selectAllClusters();" class="btn btn-success btn-sm io-btn-small">' +
                    'Select All' +
                    '</a>' +
                    '</div>' +
                    '</div>' +
                    '</div>' +
                    '<div class="form-group">' +
                    '<label class="col-sm-4 control-label">Destination Product</label>' +
                    '<div class="col-sm-8">' +
                    '<div class="input-group ui-select-input-field">' +
                    '<ui-select ui-select-no-animate multiple ng-model="cloneObj.destProductIds" theme="bootstrap" sortable="true" class="form-control" close-on-select="false" tagging="tagHandler" style="max-width:50%;">' +
                    '<ui-select-match placeholder="Select one or more products...">{{$item.name}}</ui-select-match>' +
                    '<ui-select-choices class="ui-select-choices-list" repeat="opt.id as opt in products | propsFilter: {name: $select.search}" position="down">' +
                    '<div ng-bind-html="opt.name | highlight: $select.search"></div>' +
                    '</ui-select-choices>' +
                    '</ui-select>' +
                    '<span class="input-group-btn cluster-clear">' +
                    '<button ng-click="cloneObj.destProductIds = undefined" class="btn btn-warning btn-sm">' +
                    '<b>X</b>' +
                    '</button>' +
                    '</span>' +
                    '</div>' +
                    '<a ng-click="selectAllProducts();" class="btn btn-success btn-sm io-btn-small">' +
                    'Select All' +
                    '</a>' +
                    '</div>' +
                    '</div>' +
                    '</div>' +
                    '<div class="form-group">' +
                    '<label class="col-sm-4 control-label">Content Type</label>' +
                    '<div class="col-sm-8">' +
                    '<div class="input-group ui-select-input-field">' +
                    '<ui-select ui-select-no-animate multiple ng-model="cloneObj.lookupTypeIds" theme="bootstrap" sortable="true" class="form-control" close-on-select="false" tagging="tagHandler" style="max-width:50%;">' +
                    '<ui-select-match placeholder="Select one or more Content types...">{{$item.name}}</ui-select-match>' +
                    '<ui-select-choices class="ui-select-choices-list" repeat="opt.id as opt in contentTypes | propsFilter: {name: $select.search}" position="down">' +
                    '<div ng-bind-html="opt.name | highlight: $select.search"></div>' +
                    '</ui-select-choices>' +
                    '</ui-select>' +
                    '<span class="input-group-btn cluster-clear">' +
                    '<button ng-click="cloneObj.lookupTypeIds = undefined" class="btn btn-warning btn-sm">' +
                    '<b>X</b>' +
                    '</button>' +
                    '</span>' +
                    '</div>' +
                    '<a ng-click="selectAllContentTypes();" class="btn btn-success btn-sm io-btn-small">' +
                    'Select All' +
                    '</a>' +
                    '</div>' +
                    '</div>' +
                    '</div>' +
                    '<div class="modal-footer">' +
                    '<button class="btn btn-primary" ng-click="cloneLookupContent(cloneForm)">OK</button>' +
                    '<button class="btn btn-warning" ng-click="cancel()">Cancel</button>' +
                    '</div>' +
                    '</form>');
                elem.append(modal);
                return modal;
            }

            function lookupContentForClusterClone() {
                var modal = angular.element(
                    '<div class="modal-header">' +
                    '<h3 class="modal-title">Clone All Product Lookup Content</h3>' +
                    '</div>' +
                    '<div class="modal-body">' +
                    '<form class="form-horizontal" name="cloneForm">' +
                    '<div class="form-group">' +
                    '<label class="col-sm-4 control-label">Source Business Unit</label>' +
                    '<div class="col-sm-8">' +
                    '<div class="input-group">' +
                    '<select class="form-control" ng-model="cloneObj.sourceClusterId" ng-options="opt.id as opt.name for opt in clusterArr"></select>' +
                    '<span class="input-group-btn cluster-clear">' +
                    '<button ng-click="cloneObj.sourceClusterId = undefined" class="btn btn-warning btn-sm">' +
                    '<b>X</b>' +
                    '</button>' +
                    '</span>' +
                    '</div>' +
                    '</div>' +
                    '</div>' +
                    '<div class="form-group">' +
                    '<label class="col-sm-4 control-label">Destination Business Unit</label>' +
                    '<div class="col-sm-8">' +
                    '<div class="input-group ui-select-input-field custom-input-size">' +
                    '<ui-select ui-select-no-animate multiple ng-model="cloneObj.destClusterIds" theme="bootstrap" sortable="true" class="form-control" close-on-select="false" tagging="tagHandler" style="max-width:55%;">' +
                    '<ui-select-match placeholder="Select one or more business units...">{{$item.name}}</ui-select-match>' +
                    '<ui-select-choices class="ui-select-choices-list" repeat="opt.id as opt in clusterArr | propsFilter: {name: $select.search}" position="down">' +
                    '<div ng-bind-html="opt.name | highlight: $select.search"></div>' +
                    '</ui-select-choices>' +
                    '</ui-select>' +
                    '<span class="input-group-btn cluster-clear-custom">' +
                    '<button ng-click="cloneObj.destClusterIds = undefined" class="btn btn-warning btn-sm">' +
                    '<b>X</b>' +
                    '</button>' +
                    '</span>' +
                    '</div>' +
                    '<a ng-click="selectAllClusters();" class="btn btn-success btn-sm io-btn-small">' +
                    'Select All' +
                    '</a>' +
                    '</div>' +
                    '</div>' +
                    '</div>' +
                    '</form>' +
                    '</div>' +
                    '<div class="modal-footer">' +
                    '<button class="btn btn-primary" ng-click="cloneLookupForClusterContent(cloneForm)">OK</button>' +
                    '<button class="btn btn-warning" ng-click="cancel()">Cancel</button>' +
                    '</div>');
                elem.append(modal);
                return modal;
            }

            function comment() {
                var modal = angular.element(
                    '<div class="modal-header">' +
                    '<h3 class="modal-title">{{ titleText }}</h3>' +
                    '</div>' +
                    '<div class="modal-body">' +
                    '<form name="formObj" sf-schema="schema" sf-form="commentForm" sf-model="model" class="form-horizontal"></form>' +
                    '</div>' +
                    '<div class="modal-footer">' +
                    '<button class="btn btn-primary" ng-click="postComment(formObj)">{{ buttonText }}</button>' +
                    '<button class="btn btn-warning" ng-click="cancel()">Cancel</button>' +
                    '</div>');
                elem.append(modal);
                return modal;
            }

            function buySheet() {
                var modal = angular.element(
                    '<div class="buySheetContainer">' +
                    '<div class="modal-header">' +
                    '<h3 class="modal-title">Buy Sheet <small>Preview</small></h3>' +
                    '</div>' +
                    '<div id="printContainer">' +
                    '<div class="modal-body buySheet">' +
                    '<div class="row">' +
                    '<div class="col-xs-6">' +
                    '<p>' +
                    '{{order.client_name}}' +
                    '</p>' +
                    '<table class="table table-bordered buy_table">' +

                    '<thead>' +
                    '<tr class="buy_bg">' +
                    '<th colspan="2"><b>{{order.client_first_name}} {{order.client_last_name}}</b></th>' +
                    '</tr>' +
                    '</thead>' +
                    '<tbody>' +
                    '<tr>' +
                    '<td>Sales Region</td>' +
                    '<td><span>{{order.sales_region_id[1]}}</span></td>' +
                    '</tr>' +
                    '<tr>' +
                    '<td>Account Manager</td>' +
                    '<td>{{order.submit_user_name}}</td>' +
                    '</tr>' +
                    '<tr>' +
                    '<td>Digital Sales Rep</td>' +
                    '<td>{{order.salesperson_id[1]}}</td>' +
                    '</tr>' +
                    '<tr>' +
                    '<td>MMSC</td>' +
                    '<td></td>' +
                    '</tr>' +
                    '<tr>' +
                    '<td>Retention Specialist</td>' +
                    '<td></td>' +
                    '</tr>' +
                    '</table><br/>' +

                    '<table class="table table-bordered buy_table">' +
                    '<tr>' +
                    '<td>Account #</td>' +
                    '<td>{{order.client_crm_id}}</td>' +
                    '</tr>' +
                    '<tr>' +
                    '<td>Order #</td>' +
                    '<td>{{order.id}}</td>' +
                    '</tr>' +
                    '<tr>' +
                    '<td>Agency</td>' +
                    '<td></td>' +
                    '</tr>' +
                    '<tr>' +
                    '<td>Package</td>' +
                    '<td></td>' +
                    '</tr>' +
                    '<tr>' +
                    '<td>Co-op: (Y/N)</td>' +
                    '<td></td>' +
                    '</tr>' +
                    '<tr>' +
                    '<td>Adtaxi: (Y/N)</td>' +
                    '<td></td>' +
                    '</tr>' +
                    '<tr>' +
                    '<td>Dashboard Required: (Y/N)</td>' +
                    '<td>' +
                    '{{order.dashbaord?"Yes":"No"}}' +
                    '<p class="pull-right">*required $1,500 monthly buy</p>' +
                    '</td>' +
                    '</tr>' +
                    '<tr>' +
                    '<td>Screenshots Required: (Y/N)</td>' +
                    '<td>' +
                    '<p class="pull-right">*not available on AdTaxi Ads</p>' +
                    '</td>' +
                    '</tr>' +
                    '<tr>' +
                    '<td>Objective</td>' +
                    '<td>{{order.goals}}</td>' +
                    '</tr>' +
                    '<tr>' +
                    '<td>Strategy</td>' +
                    '<td>{{order.goal_notes}}</td>' +
                    '</tr>' +
                    '</tbody>' +
                    '</table>' +
                    '<p>' +
                    'Phone: {{order.client_contact_phone}}' +
                    '</p>' +
                    '</div>' +
                    '<div class="col-xs-6">' +
                    '<img ng-if="buySheet.img" ng-src="{{buySheet.img}}"  alt="Company Logo" class="img-responsive pull-right"/>' +
                    '</div>' +
                    '</div>' +
                    '<div class="row">' +
                    '<div class="col-xs-12">' +
                    '<table class="table table-bordered">' +
                    '<thead>' +
                    '<tr class="buy_bg">' +
                    '<th> Display</th>' +
                    '<th> Category</th>' +
                    '<th> Network - Product</th>' +
                    '<th> Campaign Name</th>' +
                    '<th> Targeting Type</th>' +
                    '<th> Unit - Size</th>' +
                    '<th> Start Date</th>' +
                    '<th> End Date</th>' +
                    '<th> Est Imp</th>' +
                    '<th> Sponsorship</th>' +
                    '<th> Delivery Type</th>' +
                    '<th> Monthly Impression Goal</th>' +
                    '<th> Monthly Billing </th>' +
                    '<th> Total Budget</th>' +
                    '<th> Linking URL</th>' +
                    '</tr>' +
                    '</thead>' +
                    '<tbody>' +
                    '<tr ng-repeat="lineItem in lineItems">' +
                    '<td>{{lineItem.display}}</td>' +
                    '<td>{{lineItem.category}}</td>' +
                    '<td>{{lineItem.networkProduct}}</td>' +
                    '<td>{{lineItem.campaign_name}}</td>' +
                    '<td>{{lineItem.targetingType}}</td>' +
                    '<td>{{lineItem.unitSize}}</td>' +
                    '<td>{{lineItem.startDate}}</td>' +
                    '<td>{{lineItem.endDate}}</td>' +
                    '<td>{{lineItem.estImpressions}}</td>' +
                    '<td>{{lineItem.sponsorship}}</td>' +
                    '<td>{{lineItem.deliveryType}}</td>' +
                    '<td>{{lineItem.mig}}</td>' +
                    '<td>{{lineItem.monthlyBilling}}</td>' +
                    '<td>{{lineItem.totalBudget}}</td>' +
                    '<td class="breakWord">{{lineItem.linkingUrl}}</td>' +
                    '</tr>' +
                    '</tbody>' +
                    '</table>' +
                    '</div>' +
                    '</div>' +
                    '<div class="row buy_textTable_row">' +
                    '<div class="col-xs-10 col-xs-offset-1">' +
                    '<table class="table buy_textTable">' +
                    '<tr>' +
                    '<td>_</td>' + '<td>_</td>' +
                    '</tr>' +
                    '<tbody>' +

                    '<tr>' +
                    '<td>Delivery:</td>' +
                    '<td>' +
                    'Standard creative assets should be received and any changes must be delivered 3 business days prior to scheduled launch.' +
                    'Delivery Metrics are based on the Yahoo! Apt adserving platform.' +
                    'Video creative assets should be received and any changes must be delivered 5 business days prior to scheduled launch.' +
                    'Social Facebook: As your agency, we will never remove your admin access to your own page.' +
                    '</td>' +
                    '</tr>' +
                    '<tr>' +
                    '<td>Terms &amp; Conditions:</td>' +
                    '<td>' +
                    'Standard creative assets should be received and any changes must be delivered 3 business days prior to scheduled launch.' +
                    'Delivery Metrics are based on the Yahoo! Apt adserving platform.' +
                    'Video creative assets should be received and any changes must be delivered 5 business days prior to scheduled launch.' +
                    'Social Facebook: As your agency, we will never remove your admin access to your own page.' +
                    '</td>' +
                    '</tr>' +
                    '<tr>' +
                    '<td>Line Items:</td>' +
                    '<td>' +
                    'The individual named as Media Contact above approve the change or addition of any line item in any material manner via email. Publisher and ADS will provide advertiser with a work order to review and ensure that the changes or additions. Changes are considered accepted when acknowledgement of the work order is received from the Media Contact to Publisher and ADS via email.' +
                    '</td>' +
                    '</tr>' +
                    '<br/>' +
                    '</tbody>' +
                    '</table>' +
                    '</div>' +
                    '<div class="col-xs-1"></div>' +
                    '</div>' +
                    '<div class="row">' +
                    '<div class="col-xs-10 col-xs-offset-1">' +
                    '<p>Insertion order is not considered accepted until we send written confirmation of receipt.</p>' +
                    '</div>' +
                    '</div>' +
                    '<br/><br/>' +
                    '<div class="row buy_underlined">' +
                    '<div class="col-xs-7 col-xs-offset-1">' +
                    'Authorized Signature Advertiser or Agency:' +
                    '</div>' +
                    '<div class="col-xs-3">' +
                    'Date:' +
                    '</div>' +
                    '</div>' +
                    '<br/><br/>' +
                    '<div class="row buy_underlined">' +
                    '<div class="col-xs-7 col-xs-offset-1">' +
                    'Authorized Signature ADS:' +
                    '</div>' +
                    '<div class="col-xs-3">' +
                    'Date:' +
                    '</div>' +
                    '</div>' +
                    '<br/><br/><br/>' +
                    '</div>' +
                    '</div>' +
                    '<div class="modal-footer">' +
                    '<button class="btn btn-default" type="button" ng-click="closeSheet()">Close</button>' +
                    '<button class="btn btn-default" type="button" ng-click="downloadPdf()">Download</button>' +
                    '<button class="btn btn-primary" type="button" ng-click="printDiv2()">Print</button>' +
                    '</div>' +
                    '</div>');
                elem.append(modal);
                return modal;
            }

            function orderWatchersListModel() {
                var modal = angular.element(
                    '<div class="modal-header">' +
                    '<h3 class="modal-title">Add Order Watchers</h3>' +
                    '</div>' +
                    '<div class="modal-body mb10">' +
                    '<div class="row form-group">' +
                    '<label class="col-sm-1 control-label add-watcher-list">Watchers</label>' +
                    '<div class="col-sm-10">' +
                    '<div class="input-group">' +
                    '<ui-select ui-select-no-animate multiple ng-model="modalObj.selectedUsers" theme="bootstrap" ng-disabled="disabled" class="btn-group" sortable="true" close-on-select="false" tagging="tagHandler">' +
                    '<ui-select-match placeholder="Select content...">{{$item.first_name}} {{$item.last_name}}</ui-select-match>' +
                    '<ui-select-choices class="ui-select-choices-list" repeat="user in users|propsFilter: {first_name: $select.search, last_name: $select.search}">' +
                    '<div ng-bind-html="user.first_name + \' \' + user.last_name | highlight: $select.search"></div>' +
                    '</ui-select-choices>' +
                    '</ui-select>' +
                    '<span class="input-group-btn">' +
                    '<button ng-click="modalObj.selectedUsers = []" class="btn btn-warning btn-sm">' +
                    '<b>X</b>' +
                    '</button>' +
                    '</span>' +
                    '</div>' +
                    '</div>' +
                    '</div>' +
                    '</div>' +
                    '<div class="modal-footer">' +
                    '<button class="btn btn-primary" ng-click="ok()">OK</button>' +
                    '<button class="btn btn-warning" ng-click="cancel()">Cancel</button>' +
                    '</div>');
                elem.append(modal);
                return modal;
            }

            function createNewForm() {
                var modal = angular.element(
                    '<div class="modal-header">' +
                    '<h3 class="modal-title">{{headerText}}</h3>' +
                    '</div>' +
                    '<form class="form-horizontal" name="orderForm">' +
                    '<div class="modal-body">' +
                    '<div class="form-group">' +
                    '<label class="col-sm-4 control-label required">Form Name</label>' +
                    '<div class="col-sm-8">' +
                    '<input type="text" class="form-control" ng-model="formObj.name" ng-required="true">' +
                    '</div>' +
                    '</div>' +
                    '<div class="form-group">' +
                    '<label class="col-sm-4 control-label required">Type Id</label>' +
                    '<div class="col-sm-8">' +
                    '<select class="form-control" ng-model="formObj.contentTypeId" ng-options="opt.id as opt.name for opt in formListType"></select>' +
                    '</div>' +
                    '</div>' +
                    '<div class="form-group" ng-if="formObj.contentTypeId == 2 || formObj.contentTypeId == 3">' +
                    '<label class="col-sm-4 control-label"></label>' +
                    '<div class="col-sm-8" ng-if="formObj.clusterIds.length > 0 || formObj.isDefault">' +
                    '<label class="control-label">To deactivate, clear business units and default form flag.</label>' +
                    '</div>' +
                    '<div class="col-sm-8" ng-if="(formObj.clusterIds == null || formObj.clusterIds.length == 0) && !formObj.isDefault">' +
                    '<label class="control-label">To activate, select business units and/or make it the default form.</label>' +
                    '</div>' +
                    '</div>' +
                    '<div class="form-group" ng-if="formObj.contentTypeId == 1">' +
                    '<label class="col-sm-4 control-label"></label>' +
                    '<div class="col-sm-8" ng-if="formObj.taskIds.length > 0">' +
                    '<label class="control-label">To deactivate, clear the tasks.</label>' +
                    '</div>' +
                    '<div class="col-sm-8" ng-if="formObj.taskIds == null || formObj.taskIds.length == 0">' +
                    '<label class="control-label">To activate, select one or more tasks for this form.</label>' +
                    '</div>' +
                    '</div>' +
                    '<div class="form-group custom-form-group" ng-if="formObj.contentTypeId == 2 || formObj.contentTypeId == 3">' +
                    '<label class="col-sm-4 control-label">Business Unit</label>' +
                    '<div class="col-sm-8">' +
                    '<div class="input-group ui-select-input-field">' +
                    '<ui-select ui-select-no-animate multiple ng-model="formObj.clusterIds" on-remove="handleOnRemovalBusinessUnit(formObj.clusterIds)" on-select="handleOnSelectionBusinessUnit(formObj.clusterIds)" theme="bootstrap" sortable="true" class="form-control" close-on-select="false" tagging="tagHandler" style="max-width:50%;">' +
                    '<ui-select-match placeholder="Select one or more clusters...">{{$item.name}}</ui-select-match>' +
                    '<ui-select-choices class="ui-select-choices-list" repeat="opt.id as opt in clusterArr | propsFilter: {name: $select.search}" position="down">' +
                    '<div ng-bind-html="opt.name | highlight: $select.search"></div>' +
                    '</ui-select-choices>' +
                    '</ui-select>' +
                    '<span class="input-group-btn cluster-clear">' +
                    '<button ng-click="handleClearBusinessUnit()" class="btn btn-warning btn-sm">' +
                    '<b>X</b>' +
                    '</button>' +
                    '</span>' +
                    '</div>' +
                    '<a ng-click="selectAllClusters();" class="btn btn-success btn-sm io-btn-small">' +
                    'Select All' +
                    '</a>' +
                    '</div>' +
                    '</div>' +
                    '<div class="form-group" ng-if="formObj.contentTypeId == 2">' +
                    '<label class="col-sm-4 control-label">Default Order Form</label>' +
                    '<div class="col-sm-8">' +
                    '<input type="checkbox" ng-model="formObj.isDefault">' +
                    '</div>' +
                    '</div>' +
                    '<div class="form-group" ng-if="formObj.contentTypeId == 3">' +
                    '<label class="col-sm-4 control-label">Default Client Form</label>' +
                    '<div class="col-sm-8">' +
                    '<input type="checkbox" ng-model="formObj.isDefault">' +
                    '</div>' +
                    '</div>' +
                    '<div class="form-group" ng-if="formObj.contentTypeId == 1">' +
                    '<label class="col-sm-4 control-label">Select Tasks</label>' +
                    '<div class="col-sm-8">' +
                    '<div class="input-group ui-select-input-field">' +
                    '<ui-select ui-select-no-animate multiple ng-model="formObj.taskIds" theme="bootstrap" sortable="true" class="form-control" close-on-select="false" tagging="tagHandler" style="max-width:50%;">' +
                    '<ui-select-match placeholder="Select one or more tasks...">{{$item.name}}</ui-select-match>' +
                    '<ui-select-choices class="ui-select-choices-list" repeat="opt.id as opt in tasksList | propsFilter: {name: $select.search}" position="down">' +
                    '<div ng-bind-html="opt.name | highlight: $select.search"></div>' +
                    '</ui-select-choices>' +
                    '</ui-select>' +
                    '<span class="input-group-btn cluster-clear"><button ng-click="handleClearTask()" class="btn btn-warning btn-sm"><b>X</b></button></span>' +
                    '</div>' +
                    '</div>' +
                    '</div>' +
                    '</div>' +
                    '<div class="modal-footer">' +
                    '<button class="btn btn-primary" ng-click="addNewForm(orderForm)">OK</button>' +
                    '<button class="btn btn-warning" ng-click="cancel()">Cancel</button>' +
                    '</div>' +
                    '</form>');
                elem.append(modal);
                return modal;
            }

            function forceAddOrUpdateForm() {
                var modal = angular.element(
                    '<div class="modal-header">' +
                    '<h3 class="modal-title">{{headerText}}</h3>' +
                    '</div>' +
                    '<div class="modal-body">' +
                    '<div class="input-group col-sm-10">' +
                    '<h4 class="modal-title">Please confirm this operation because some cascading target fields will be affected:</h4>' +
                    '<div class="form-group" style="margin-top: 20px" ng-repeat="message in messages">' +
                    '<p class="col-sm-10" style="color: red">' +
                    '{{message}}' +
                    '</p>' +
                    '</div>' +
                    '</div>' +
                    '</div>' +
                    '<div class="modal-footer">' +
                    '<button class="btn btn-primary" ng-click="forceUpdate()">Confirm</button>' +
                    '<button class="btn btn-warning" ng-click="cancel()">Cancel</button>' +
                    '</div>');
                elem.append(modal);
                return modal;
            }

            function forceAddOrUpdateFormField() {
                var modal = angular.element(
                    '<div class="modal-header">' +
                    '<h3 class="modal-title">{{headerText}}</h3>' +
                    '</div>' +
                    '<div class="modal-body">' +
                    '<div class="input-group col-sm-10">' +
                    '<h4 class="modal-title">Please confirm this operation because {{numAffectedFields ? numAffectedFields : \'some\'}} New Orders and Workflow field(s) will be affected and their values deleted:</h4>' +
                    '<div class="form-group" style="margin-top: 20px">' +
                    '<p class="col-sm-10" style="color: red">' +
                    '{{message}}' +
                    '</p>' +
                    '</div>' +
                    '</div>' +
                    '</div>' +
                    '<div class="modal-footer">' +
                    '<button class="btn btn-primary" ng-click="forceUpdate()">Confirm</button>' +
                    '<button class="btn btn-warning" ng-click="cancel()">Cancel</button>' +
                    '</div>');
                elem.append(modal);
                return modal;
            }

            function bulkStatusChangeLineItems() {
                var modal = angular.element(
                    '<div class="modal-header">' +
                    '<h3 class="modal-title">Set Bulk Status</h3>' +
                    '</div>' +
                    '<div class="modal-body">' +
                    '<div class="input-group col-sm-10">' +
                    '<h4 class="modal-title">Are you sure you want to {{bulkAction}} {{selectedItems.length}} line items ? </h4>' +
                    '</div>' +
                    '</div>' +
                    '<div class="modal-footer">' +
                    '<button class="btn btn-primary" ng-click="ok()">Continue</button>' +
                    '<button class="btn btn-warning" ng-click="cancel()">Cancel</button>' +
                    '</div>');
                elem.append(modal);
                return modal;
            }

            function assignPlacements() {
                let modal = angular.element(
                    '<div style="overflow-x: auto">' +
                    '<div class="modal-header">' +
                    '<h3 class="modal-title">Assign Placements</h3>' +
                    '<h4>Please confirm the following operations:<br/></h4>' +
                    '</div>' +
                    '<div>' +
                    '<h5 class="col-sm-12 control-label">' +
                    '<br/>Flight ids to be processed: <b>{{checkedFlightIds.join(", ")}}</b><br/></h5>' +
                    '</div>' +
                    '<div ng-if="targetLineItemId">' +
                    '<h5 class="col-sm-12 control-label">' +
                    'Flights are to be moved to line item: <b>{{targetLineItemId}}</b><br/></h5>' +
                    '</div>' +
                    '<div ng-if="checkedLineItemIds.length > 0">' +
                    '<h5 class="col-sm-12 control-label">' +
                    'Associations are to be created between the above flights and the following line items (when they did not previously exist): <b>{{checkedLineItemIds.join(", ")}}</b><br/></h5>' +
                    '</div>' +
                    '</div>' +
                    '<div class="modal-footer">' +
                    '<button class="btn btn-primary" ng-click="ok()">Confirm</button>' +
                    '<button class="btn btn-warning" ng-click="cancel()">Cancel</button>' +
                    '</div>');
                elem.append(modal);
                return modal;
            }

            function getBulkKeywords() {
                let modal = angular.element(
                    '<div style="overflow-x: auto">' +
                    '<div class="modal-header">' +
                    '<h3 class="modal-title">Keywords<br></h3>' +
                    '<p><br>Find relevant keywords by describing what you are advertising in this ad group<br></p>' +
                    '<p><i class="fa fa-link"></i>&nbsp&nbspURL<br/></p>' +
                    '<input type="text" class="form-control" ng-model="pageUrl" placeholder="Enter related web page URL" />' +
                    '<div>' +
                    '<p style="text-align: center;"><br> - And/Or - <br></p>' +
                    '<p><i class="fa fa-home"></i>&nbsp&nbspProducts or services<br/></p>' +
                    '<input type="text" class="form-control" ng-model="text" placeholder="Enter comma-separated list of products or services" />' +
                    '</div>' +
                    '<div>' +
                    '<span><br>Keywords are words or phrases that are used to match your ads with the terms people are searching for</span>' +
                    '<button class="btn btn-primary pull-right" ng-click="getKeywords()">Get Keywords</button>' +
                    '</div>' +
                    '<div>' +
                    '<table class="table adgroup-keyword-list">' +
                    '<tr ng-repeat="row in rowsOfKeywords">' +
                    '<td style="padding: 2px 15px 2px 15px;">{{row.item1}}</td>' +
                    '<td style="padding: 2px 15px 2px 15px;">{{row.item2}}</td>' +
                    '</tr>' +
                    '</table>' +
                    '</div>' +
                    '</div>' +
                    '<div class="modal-footer">' +
                    '<label class="col-sm-8" style="text-align: left;">Match types help control which searches can trigger your ads<br/>keyword = Broad match; "keyword" = Phrase match; [keyword] = Exact match</label>' +
                    '<button class="btn btn-primary" ng-click="ok()">Apply</button>' +
                    '<button class="btn btn-warning" ng-click="cancel()">Cancel</button>' +
                    '</div>' +
                    '</div>');
                elem.append(modal);
                return modal;
            }


            var types = {
                reassignTask: reassign,
                assignQueue: assignQueue,
                reassign: reassign,
                submitUser: submitUser,
                assignCampaignManager: assignCampaignManager,
                taskTimelog: taskTimelog,
                cancelReason: cancelReason,
                exceptionLogs: exceptionLogs,
                commonLog: commonLog,
                integrationForm: integrationForm,
                //fileIntegrationForm: fileIntegrationForm,
                salesforceConnectionForm: salesforceConnectionForm,
                addMapping: addMapping,
                deleteMapping: deleteMapping,
                deleteIntegration: deleteIntegration,
                inventoryEvents: inventoryEvents,
                inventoryReservedEvents: inventoryReservedEvents,
                nightlyStatus: nightlyStatus,
                notifications: notifications,
                reporting: reporting,
                updateHideConditionForm: updateHideConditionForm,
                addFormLookupContent: addFormLookupContent,
                cloneFormLookupContent: cloneFormLookupContent,
                deleteLookupContent: deleteLookupContent,
                createLookupContent: createLookupContent,
                createLookupType: createLookupType,
                deleteCreative: deleteCreative,
                deletePixel: deletePixel,
                lineItemChanges: lineItemChanges,
                flightChanges: flightChanges,
                moveFlight: moveFlight,
                autoCreateFlights: autoCreateFlights,
                showFormulaErrors: showFormulaErrors,
                redistributeValues: redistributeValues,
                addRoutingRuleSet: addRoutingRuleSet,
                addRuleSet: addRuleSet,
                createWorkflow: createWorkflow,
                createRoutingRule: createRoutingRule,
                createRoutingCondition: createRoutingCondition,
                createWorkflowTask: createWorkflowTask,
                createWorkflowTaskInterlocking: createWorkflowTaskInterlocking,
                createWorkflowAction: createWorkflowAction,
                createCustomStatus: createCustomStatus,
                createCancelReason: createCancelReason,
                createProduct: createProduct,
                createProductGroup: createProductGroup,
                cloneProduct: cloneProduct,
                cloneForm: cloneForm,
                updateProductsHideConditionForm: updateProductsHideConditionForm,
                addProductContent: addProductContent,
                lookupContentClone: lookupContentClone,
                lookupContentForClusterClone: lookupContentForClusterClone,
                buySheet: buySheet,
                orderWatchersListModel: orderWatchersListModel,
                comment: comment,
                createNewForm: createNewForm,
                forceAddOrUpdateForm: forceAddOrUpdateForm,
                forceAddOrUpdateFormField: forceAddOrUpdateFormField,
                bulkStatusChangeLineItems: bulkStatusChangeLineItems,
                assignPlacements: assignPlacements,
                getBulkKeywords: getBulkKeywords
            }
            $compile(types[scope.type]())(scope);
        }
    }
}
